import React, {Component, PropType} from 'react'
import LoadingComponent from './LoadingComponent';
import { isPlainObject } from 'lodash';
// import ReactDOMServer from 'react-dom/server';

var metric = [];
var Stack = [];
var extraParamsGlobel = [];
var timeHandle = null;
var downloadChart = null;
var spikeStyle = {
    margin: '0 auto 3.7%',
    width: '100%',
    height:'300px'
};
var deepInsightStyle = {
    margin: '0 0% 3.7%',
    width: '100%'
};
var spikeNewPageStyle = {
    margin: '0 0% 1%',
    width: '100%'
};
//Check this
//@Todo
var mobile_width='500px'
//
var hideaxis = jQuery(window).width() > mobile_width ? 1 : 0;

class ChartComponent extends React.Component{
    constructor(props) {
        super(props);
        this.state={...props,showInsight:0,highChartsState:highChartsDiv};
        // this.popOut = this.popOut.bind(this);
        this.drillFunction = this.drillFunction.bind(this);
        this.highChartsRender = this.highChartsRender.bind(this);
    }
    arePrevAndThisPropsEqual=(prevProps, nextProps)=> {
        if (nextProps.isSideInsight===true && prevProps.breakUp == nextProps.breakUp && prevProps.category == nextProps.category && prevProps.categoryValue == nextProps.categoryValue && prevProps.metric == nextProps.metric && prevProps.startDate == nextProps.startDate && prevProps.endDate == nextProps.endDate && prevProps.metricRange == nextProps.metricRange && prevProps.analysis == nextProps.analysis && prevProps.chartDispStyle == nextProps.chartDispStyle && prevProps.chartType == nextProps.chartType && prevProps.clusterCount == nextProps.clusterCount && prevProps.drill == nextProps.drill && prevProps.index == nextProps.index && prevProps.initial == nextProps.initial && prevProps.insightMetric == nextProps.insightMetric && prevProps.insightType == nextProps.insightType && prevProps.limit == nextProps.limit && prevProps.regressionLine == nextProps.regressionLine && prevProps.sortOrder == nextProps.sortOrder)
            return false;
        else
            return true;
    }
    componentWillReceiveProps=(nextProps)=> {
        //Check if component props are updated or not
        if(this.arePrevAndThisPropsEqual(this.props, nextProps)===false){
            return;
        }
        Stack = nextProps.stack;
        if (nextProps.index) {
            var chartDivId = 'container' + nextProps.index;
            var index = nextProps.index;
        } else {
            var chartDivId = 'container';
            var index = 1;
        }
        if (index == 1 && this.props && !this.props.isSideInsight) {
            timeHandle = nextProps.timeHandle;
            // drillHandleFunction = nextProps.drillHandle;
            insightHandleFunction = nextProps.insightHandle;
            downloadFunction = nextProps.downloadFunction;
        }
        metric[index] = nextProps.mainMetric;
        this.highChartsRender(nextProps, chartDivId, index);
        this.addRegressionLine(nextProps);
    }
    addRegressionLine=(nextProps)=>{
        if ((nextProps.regressionLine==="true" || nextProps.regressionLine===true) && (nextProps.analysis==='false' || !nextProps.analysis)) {
            var values = highChartsDiv
                .series[1]
                .name
                .split("=")[1]
                .split("+");
            var Description = "The Simple Linear Regression Equation is "+highChartsDiv.series[1].name.split("Equation:")[1]+". Slope of "+highChartsDiv.xAxis[0].axisTitle.textStr+" and "+highChartsDiv.yAxis[0].axisTitle.textStr+" is "+highChartsDiv.series[1].name.split("=")[1].split("+")[0].trim().split('x')[0]+", this means the correlation is ";
            Description += Math.abs(parseFloat(highChartsDiv.series[1].name.split("=")[1].split("+")[0].trim().split('x')[0])) > 0.75
                ? "High"
                : (Math.abs(parseFloat(highChartsDiv.series[1].name.split("=")[1].split("+")[0].trim().split('x')[0])) < 0.4
                    ? "Low"
                    : 'Medium');
            Description += " (" + highChartsDiv
                .series[1]
                .name
                .split("=")[1]
                .split("+")[0]
                .trim()
                .split('x')[0] + "). ";
            var sign = parseFloat(highChartsDiv.series[1].name.split("=")[1].split("+")[0].trim().split('x')[0]) > 0
                ? "Increase"
                : "Decrease";
            var valueChanged = Math.abs(parseFloat(highChartsDiv.series[1].name.split("=")[1].split("+")[0].trim().split('x')[0]))*100;
            // Description += " On every " + sign + " by "+delimitNumbersIndianFormat(valueChanged)+" of " + highChartsDiv.xAxis[0].axisTitle.textStr + " for every additional 100 "+highChartsDiv.xAxis[0].axisTitle.textStr+".";
            Description += " If " + highChartsDiv.xAxis[0].axisTitle.textStr + " increase by 100, then " + highChartsDiv.yAxis[0].axisTitle.textStr + " will "+sign+" by "+valueChanged+".";
            jQuery('.chartsInfo').html("<strong>Description : </strong>"+Description);
        }
    }
    componentDidMount() {
        Stack = this.props.stack;
        if (this.props.index) {
            var chartDivId = 'container' + this.props.index;
            var index = this.props.index;
        } else {
            var chartDivId = 'container';
            var index = 1;
        }
        if (index == 1 && this.props && !this.props.isSideInsight) {
            timeHandle = this.props.timeHandle;
            // drillHandleFunction = this.props.drillHandle;
            insightHandleFunction = this.props.insightHandle;
            downloadFunction = this.props.downloadFunction;
        }
        metric[index] = this.props.mainMetric;
        this.highChartsRender(this.props, chartDivId, index);
        this.addRegressionLine(this.props);
    }
    realTime=(e)=>{
        var chart = Highcharts.charts[0];
        chart.showLoading('Loading data from server...');
        var startDate = moment(e.min);
        var endDate = moment(e.max);
        var gran = moment
            .duration(endDate.diff(startDate))
            .asDays();
        var period = 'year';
        if (gran > 60) {
            gran = 'days';
            period = 'date';
        } else if (gran < 60 && gran >= 10) {
            gran = 'hour';
            period = 'dateTime';
        } else if (gran <= 10) {
            gran = 'min';
            period = 'dateTime';
        } else {
            gran = 'min';
            period = 'dateTime';
        }
        jQuery.ajax({
            type: 'Get',
            data: 'startDate=' + moment(startDate).format('YYYY-MM-DD') + "&endDate=" + moment(endDate).format('YYYY-MM-DD') + "&selectedProperty=" + this.props.category + "&selectedPropertyValue=" + this.props.breakup + "&breakUp=null&selectedMetric=" + this.props.selectedMetric + "&chartDisp=realTime&granularity=" + gran + "&period=" + period,
            url: '/dashboard/realtime/async',
            success: function (data) {
                // data = decodeResponseBody(data)
                checkIfSessionTimedOut(data)
                if (data.data.length != 0) 
                    chart.series[0].setData(data.data[0].data);
                else 
                    chart
                        .series[0]
                        .setData(0);
                chart.hideLoading();
            }
        });
    }
    realTimeClick= (security, endTime, startTime, granularity)=> {
        this.setState({showInsight: 1, securityGiven: security, startTime: startTime, endTime: endTime})
    }
    getTheme(configData){
        let colorArrayToUse = typeof configData['colorArray'] == "string" ? JSON.parse(configData['colorArray']) : configData['colorArray']
        let chartConfig = {
            colors: colorArrayToUse ? colorArrayToUse : ["#2f7ed8","#0d233a","#8bbc21","#910000","#1aadce","#492970","#f28f43","#77a1e5","#c42525","#a6c96a"],
            lang: {
                thousandsSep: ','
            },
            global: {
                useUTC: true
            },
            chart: {
                ignoreHiddenSeries: false,
                style: {
                    fontFamily: 'Helvetica'
                }
            }
        }
        if(SKIN_MODE=="dark"){
            chartConfig['chart']={"backgroundColor":"#1c273c"};
            
            chartConfig['xAxis']={"gridLineColor":"#707073","labels":{"style":{"color":"#E0E0E3"}},"lineColor":"#707073","minorGridLineColor":"#505053","tickColor":"#707073","tickWidth":1,"title":{"style":{"color":"#A0A0A3"}}};
            
            chartConfig['yAxis']={"gridLineColor":"#707073","labels":{"style":{"color":"#E0E0E3"}},"lineColor":"#707073","minorGridLineColor":"#505053","tickColor":"#707073","tickWidth":1,"title":{"style":{"color":"#A0A0A3"}}};
            
            chartConfig['tooltip']={backgroundColor: 'rgba(0, 0, 0, 0.85)', style: { color: '#F0F0F0' }};
            
            chartConfig['lengend']={ layout: 'horizontal',backgroundColor: 'rgba(0, 0, 0, 0.5)', itemStyle: { color: '#E0E0E3' }, itemHoverStyle: { color: '#FFF' }, itemHiddenStyle: { color: '#606063' }, title: { style: { color: '#C0C0C0' } } };
            
            chartConfig['label']={ style: { color: '#707073' }};

            chartConfig['plotOptions']={"series":{"dataLabels":{"color":"#F0F0F3","style":{"fontSize":"13px"}},"marker":{"lineColor":"#333"}},"boxplot":{"fillColor":"#505053"},"candlestick":{"lineColor":"white"},"errorbar":{"color":"white"}};
        }
        return chartConfig;
    }
    highChartsRender=(chartsData, chartDivId, index)=>{
        var mobile_width='800'
        var tablet_width='1300'
        var hideaxis = jQuery(window).width() > mobile_width ? 1 : 0;
        var data = chartsData.data.data,
            period = chartsData.period,
            trend_hover_information = chartsData.trend_hover_information ? chartsData.trend_hover_information : 'growth',            
            compare = chartsData.compare?chartsData.compare.toString():null,
            dataLabelConfig = chartsData.dataLabelConfig,
            yAxis = chartsData.yAxis
        // if (index == 1 && this.props && !this.props.isSideInsight) {
        //     drillGlobalObj = chartsData.data.drill;
        //     var drillUp = JSON.stringify(drillGlobalObj.drillUp),
        //         drillDown = JSON.stringify(drillGlobalObj.drillDown),
        //         drillAcross = JSON.stringify(drillGlobalObj.drillAcross);
        // } else {
        //     var drillUp = null,
        //         drillDown = null,
        //         drillAcross = null;
        // }
        drillGlobalObj = chartsData.data.drill;
        var drillUp = JSON.stringify(drillGlobalObj?.drillUp),
            drillDown = JSON.stringify(drillGlobalObj?.drillDown),
            drillAcross = JSON.stringify(drillGlobalObj?.drillAcross);
        var selectedMetric = [];        
        selectedMetric[index] = chartsData?.selectedMetric && chartsData
            .selectedMetric
            .split(',');
        var selectedMetricColumnlineSpecialCase = []
        if(chartsData.selectedMetricColumnlineSpecialCase) {
            selectedMetricColumnlineSpecialCase[index] = chartsData.selectedMetricColumnlineSpecialCase.split(',');
        }
        function getCustomWeekRange(date) {
            let momentDate = moment(date);
            let day = momentDate.date(); // Get day of the month
            let month = momentDate.format('MMMM, YYYY'); // Get month and year
        
            let startDay, endDay;
        
            if (day <= 7) {
                startDay = 1;
                endDay = 7;
            } else if (day <= 14) {
                startDay = 8;
                endDay = 14;
            } else if (day <= 21) {
                startDay = 15;
                endDay = 21;
            } else {
                startDay = 22;
                endDay = momentDate.endOf('month').date(); // Last day of the month
            }
        
            return `${String(startDay).padStart(2, '0')} ${month} - ${String(endDay).padStart(2, '0')} ${month}`;
        }
        
        var realTime = false;
        var chartCat = chartsData.chartCat;
        if(chartsData.isSideInsight) {
            // chartCat.indexOf('Column') > -1 || 
            chartCat = chartCat.indexOf('Area') > -1 || chartCat.indexOf('Waterfall') > -1 || chartCat.indexOf('Bullet') > -1 ? 'Line' : chartCat;
        }
        var chartName = [];
        var newMetricPossibleCombinations;
        chartName[index] = chartCat;
        var  reactObj= this;
        if (chartName[index] == 'realTime') {
            var temp = {
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        point: {},
                        marker: ''
                    }
                }
            };
            var demoTemp = {
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        point: {}
                    }
                }
            };
            if (handleClickLine) 
                temp.plotOptions = {
                    series: {
                        cursor: 'pointer',
                        point: {
                            events: {
                                click: function (e) {
                                    handleClickLine(moment(e.point.key).format('YYYY-MM-DD'));
                                    openSidebar('SpikeDiv', "560px");
                                    jQuery("#main-content").css("marginRight", "550px");
                                }
                            }
                        },
                        // marker: {
                        //     lineWidth: 1,
                        //     enabled:false
                        // }
                    }
                };
            mainBreakUpValue = chartsData.breakup;
            mainCategoryValue = chartsData.category;
            var clickEventTrue = false;
            var myValue = null;
            breakUpValue = mainBreakUpValue.split(',');
            breakUpValue.map(function (innerData) {
                if (innerData.split(';')[1] == 'Security') {
                    clickEventTrue = true;
                    myValue = innerData;
                }
            });
            if (mainCategoryValue.split(';')[1] == 'Security') {
                clickEventTrue = true;
                myValue = mainCategoryValue;
            }
            handleEvent = this.realTimeClick;
            if (clickEventTrue) 
                demoTemp.plotOptions = {
                    series: {
                        cursor: 'pointer',
                        marker: {
                            enabled: false,
                        },            
                        point: {
                            events: {
                                click: function (e) {
                                    if (e.point.Security) {
                                        handleEvent(myValue, moment.utc(e.point.x).add(2, 'minute').format('YYYY-MM-DD HH:mm'), moment.utc(e.point.x).subtract(2, 'minute').format('YYYY-MM-DD HH:mm'), gran);
                                    }
                                }
                            }
                        }
                    }
                };
            Highcharts.setOptions({
                global: {
                    useUTC: true
                }
            });
            Highcharts.stockChart('container', {
                chart: {
                    type: 'line',
                    zoomType: 'x'
                },
                plotOptions: demoTemp.plotOptions,
                navigator: {
                    adaptToUpdatedData: false,
                    series: {
                        data: data[0].data
                    }
                },
                scrollbar: {
                    liveRedraw: false
                },
                rangeSelector: {
                    buttons: [
                        {
                            type: 'hour',
                            count: 1,
                            text: '1h'
                        }, {
                            type: 'day',
                            count: 1,
                            text: '1d'
                        }, {
                            type: 'month',
                            count: 1,
                            text: '1m'
                        }, {
                            type: 'month',
                            count: 3,
                            text: '3m'
                        }, {
                            type: 'year',
                            count: 1,
                            text: '1y'
                        }, {
                            type: 'all',
                            text: 'All'
                        }
                    ],
                    inputEnabled: false, // it supports only days
                    selected: 5 // all
                },
                xAxis: {
                    events: {
                        afterSetExtremes: this.realTime
                    },
                    minRange: 3600 * 1000 // one hour
                },
                yAxis: {
                    floor: 0,
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    useHTML: true,
                    headerFormat: '',
                    crosshairs: true,
                    shared: true,
                    pointFormatter: function () {
                        metricData = '';
                        for (i = 0; i < selectedMetric[index].length; i++) {
                            axis = this.y;
                            var innerData = refineData(selectedMetric[index][i]);
                            
                            // Calculate growth to be shown in the tooltip
                            if (this.series.data[this.index - 1]) {
                                if (this.y && this.series.data[this.index - 1].y) 
                                    var demo = ((this.y - this.series.data[this.index - 1].y) / this.series.data[this.index - 1].y) * 100;
                                else if (this.y) {
                                    var demo = 'N.A.';
                                } else if (this.series.data[this.index - 1].y) 
                                    var demo = ((0 - this.series.data[this.index - 1].y) / this.series.data[this.index - 1].y) * 100;
                                else 
                                    var demo = 0;

                                demo = demo == 'N.A.' ? demo : delimitNumbersIndianFormat(demo);
                                if (demo[0] != '-' && demo != 'N.A.') {
                                    demo = '+' + demo;
                                    var spanClass = "text-green";
                                } else 
                                    var spanClass = "text-red";
                                demo = demo == 'N.A.'
                                    ? "&nbsp;<span class='" + spanClass + "'>(" + demo + ")<span>"
                                    : "&nbsp;<span class='" + spanClass + "'>(" + demo + "%)<span>";
                            } else 
                                demo = '';
                            if (innerData.metricPrefix == 'true') 
                                metricData += '<tr><th>' + innerData.label + ':</th><td>' +  (innerData.metricUnit==null?"":innerData.metricUnit) + '' + delimitNumbersIndianFormat(axis) + '' + demo + '</td></tr>';
                            else 
                                metricData += '<tr><th>' + innerData.label + ':</th><td>' + delimitNumbersIndianFormat(axis) + '' +  (innerData.metricUnit==null?"":innerData.metricUnit) + '' + demo + '</td></tr>';
                            }
                        if (this.key) {
                            chartSeriesName = this.key;
                        } else {
                            chartSeriesName = moment
                                .utc(this.x)
                                .format('dddd, MMM DD,YYYY HH:mm');
                            metricData = '<tr><td class="tableNumber">' + this.text + '</td></tr>';
                        }
                        return ('<table><tr><th colspan="2"><h6>' + chartSeriesName + '</h6></th></tr>' + metricData + '</table>');
                    },
                    footerFormat: '',
                    followPointer: true
                },
                series: [
                    {
                        data: data[0].data,
                        dataGrouping: {
                            enabled: false
                        },
                        id: 'dataseries'
                    }, {
                        type: 'flags',
                        data: chartsData.data.flag,
                        onSeries: 'dataseries',
                        shape: 'circlepin',
                        width: 16
                    }
                ]
            });
        } else {
            let configData = chartsData['dashboard_config'] ? (typeof chartsData['dashboard_config'] == "string" ? JSON.parse(chartsData['dashboard_config']) : chartsData['dashboard_config']) : { "legend": false,
            "gridline": true, "x_axis": true, "y_axis": true, "x_axis_label": true, "y_axis_label": true, "data_labels": true, "information": true, color: colorArray};

            var that = this;
            var toolTipData = ''
            
            jQuery(function () {
                var chart;
                let theme = that.getTheme(configData);
                Highcharts.setOptions(theme);
                var ContextMenuData = '';
                data.tooltip = {
                    useHTML: true,
                    headerFormat: '',
                    crosshairs: chartName[index].toLowerCase() == "solidgauge" ? false : true,
                    shared: toolTipConfig == 'single' || chartName[index].toLowerCase() == "solidgauge" ? false : true,
                    formatter: function () {
                        if (this.points) {
                            if (this.points[0].series.name && chartName[index].toLowerCase() == 'scatter') {
                                metricData = '<table style="text-align:left ! important"><tr><th colspan="2">' + this.points[0].series.name + '</th></tr>';
                                return metricData;
                            }
                            if(chartName[index].toLowerCase() == 'xrange'){
                                var labelName = null;
                                if(chartsData.selectedMetric_new.split(",").length>1){
                                    var innerData = refineData(chartsData.selectedMetric_new.split(",")[this.points[0].y], metric[index], metricFunction);
                                    labelName = innerData.label;
                                }else {
                                    var innerData = refineData(chartsData.selectedMetric_new.split(",")[0], metric[index], metricFunction);
                                    labelName = this.points[0].yCategory;
                                }
                                var value = this.points[0].x2 - this.points[0].x;
                                value = number_shorten(value, innerData.roundOff, innerData.numberShorten);
                                metricData = '<table style="text-align:left ! important"><tr><th colspan="2">' + labelName + ": " + value + '</th></tr>';
                                return metricData;
                            }
                        }
                        var metricData = '';

                        // Set toolTip data
                        var headerValue = null;
                        if (this.points === undefined) {
                            var series = this.series, // get all series
                                indexPoint = this.point.index, // get index
                                point = this.point, //get point
                                str = '';
                            if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') 
                                if ((this.x).search(/[a-z]/i) == -1) 
                                    headerValue = moment(this.x).format('DD MMMM,YYYY');
                                else 
                                    headerValue = this.point.name ? this.point.name : this.point.category;
                            else 
                                headerValue = this.point.name ? this.point.name : this.point.category;

                            if(chartName[index].toLowerCase() == 'map'){
                                headerValue = this.point.name ? this.point.name : this.point.options.name
                            }
                            // Set header of tooltip
                            metricData = `<table style="text-align:left ! important"><tr><th colspan="2"><h6 id="headerToolTip">${headerValue?headerValue:""}</h6></th></tr>`;

                            // Set data of tooltip
                            let metricTouse = this['series']?.['userOptions']?.['value']
                            let metricKeyValue = chartsData.data.metricKeyValue
                            if (metricKeyValue && this['series']?.['userOptions']?.['name']) {
                                metricTouse = metricKeyValue[this['series']['userOptions']['name']]
                            } else {
                                metricTouse = metricTouse;
                            }
                            let metricToSend = [];
                            metricToSend[index] = metricTouse ? [metricTouse] : selectedMetric[index];
                            newMetricPossibleCombinations = createCombination(chartsData?.mainMetric ? chartsData?.mainMetric : metricGlobal, metricFunction);


                            metricData += tooltipFormat(indexPoint, point, series, index, metricToSend, chartName, null, null, null, trend_hover_information,newMetricPossibleCombinations,that);
                            toolTipData = metricData
                        } else {
                            // Set header of tooltip
                            var tempEndDate = endDate ? endDate : this.x;
                            if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') {
                                if (period?.toLowerCase() == 'week' && analysis!="runrate") {
                                    // if (endDate <= moment(this.x).endOf('week').format('YYYY-MM-DD')) {
                                    //     headerValue = moment(this.x).format('DD MMMM, YYYY') + ' - ' + moment(endDate).endOf('week').format('DD MMMM, YYYY')
                                    // } else 
                                        headerValue =  getCustomWeekRange(this.x)
                                        //  moment(this.x).format('DD MMMM, YYYY') + ' - ' + moment(this.x)
                                        //     .subtract(1, 'd')
                                        //     .endOf('week')
                                        //     .add(1, 'd')
                                        //     .format('DD MMMM, YYYY');
                                    }
                                else if (period == 'day' && analysis!="runrate") {
                                    headerValue = moment(this.x).format('DD MMMM, YYYY');
                                } else if (period == 'month' && compare!="true" && analysis!="runrate") {
                                    var tempfirstDate = moment(this.x, 'MMMM,YYYY').format('YYYY-MM-DD') < startDate
                                        ? moment(startDate).format('YYYY-MM-DD')
                                        : moment(this.x, 'MMMM,YYYY').format('YYYY-MM-DD');
                                    if (endDate <= moment(this.x, 'MMMM,YYYY').endOf('month').format('YYYY-MM-DD')) {
                                        // headerValue = moment(tempfirstDate).format('DD MMMM, YYYY') + ' - ' + moment(endDate).format('DD MMMM, YYYY');
                                        headerValue = moment(tempfirstDate).format('DD MMMM, YYYY');
                                    } else{
                                        // headerValue = moment(tempfirstDate).format('MMMM, YYYY') + ' - ' + moment(this.x, 'MMMM, YYYY')
                                        // .endOf('month')
                                        // .format('MMMM, YYYY');
                                        headerValue = moment(tempfirstDate).format('MMMM, YYYY') 
                                    } 
                                        
                                }
                                else if (period == 'quarter' && compare!="true" && analysis!="runrate") {
                                    var q = (this.x).split(',');
                                    var qNo = q[0].split(' ');
                                    if(fyMonth){
                                        qNo = (parseInt(qNo[1]) + 1) % 4;
                                        var year = (qNo == 1 ? parseInt(q[1]) + 1 : parseInt(q[1]))-1;
                                    }
                                    else {
                                        qNo = parseInt(qNo[1]);
                                        var year = parseInt(q[1]);
                                    }
                                    var format = year + '-MM-DD';
                                    var startQuarter = moment(moment().quarter(qNo).startOf('quarter')).format(format);
                                    var endQuarter = moment(moment().quarter(qNo).endOf('quarter')).format(format);
                                    var tempfirstDate = startQuarter < startDate
                                        ? moment(startDate).format('YYYY-MM-DD')
                                        : startQuarter;
                                    if (endDate <= endQuarter) {
                                        // headerValue = moment(tempfirstDate).format('DD MMMM, YYYY') + ' - ' + moment(endDate).format('DD MMMM, YYYY');
                                        headerValue = moment(tempfirstDate).format('DD MMMM, YYYY') ;
                                    } else 
                                        // headerValue = moment(tempfirstDate).format('DD MMMM, YYYY') + ' - ' + moment(endQuarter).format('DD MMMM, YYYY');
                                        headerValue = moment(tempfirstDate).format('DD MMMM, YYYY') ;
                                    }
                                else if (period == 'year' && analysis!="runrate") {
                                    //split to find is financial year data. and set flag for UI manipulation
                                    if (this.x.split(' ')[0] === 'FY') {
                                        this.x = (this.x.split(' ')[1])-1;
                                        var fyFlag = 3;
                                    } else {
                                        this.x = this
                                            .x
                                            .split(' ')[0];
                                        var fyFlag = 0;
                                    }
                                    // set startDate by adding number of months to year so that financial is handled
                                    // here.
                                    var tempfirstDate = moment(this.x, 'YYYY').add(fyFlag, 'months').format('YYYY-MM-DD') < startDate ? moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : moment(this.x, 'YYYY').add(fyFlag, 'months').format('YYYY-MM-DD');
                                    headerValue = this.x;
                                    // var tempEndDate = endDate ? endDate : moment(this.x, 'YYYY').endOf('year').format('YYYY-MM-DD');
                                // }

                                    // if (tempfirstDate === moment(this.x, 'YYYY').format('YYYY-MM-DD') &&
                                    //     tempEndDate === moment(this.x, 'YYYY').endOf('year').format('YYYY-MM-DD')) {

                                    //     headerValue = this.x;  // Show only the year

                                    // } else if (tempEndDate <= moment(this.x, 'YYYY').endOf('year').add(fyFlag, 'months').format('YYYY-MM-DD')) {

                                    //     headerValue = moment(tempfirstDate, 'YYYY-MM-DD').format('DD MMMM, YYYY') +
                                    //         ' - ' + moment(tempEndDate, 'YYYY-MM-DD').format('DD MMMM, YYYY');

                                    // } else {

                                    //     headerValue = moment(tempfirstDate, 'YYYY-MM-DD').format('DD MMMM, YYYY') +
                                    //         ' - ' + moment(this.x, 'YYYY').endOf('year').add(fyFlag, 'months').format('DD MMMM, YYYY');
                                    // }
                                }
                                else 
                                    headerValue = this.x;
                                }
                            else if(chartName[index].toLowerCase()=="waterfall"){
                                headerValue = this.points[0].key;
                            }else  
                                headerValue = this.x;
                            if (headerValue) {
                                if (headerValue.length > 35) 
                                    headerValue = headerValue.substring(0, 30) + '...';
                            }
                            headerValue = headerValue ? headerValue : 'Total'
                            // Set header of tooltip
                            metricData = `<table style="text-align:left ! important"><tr><th colspan="2"><h6 id="headerToolTip">${headerValue}</h6></th></tr>`;
                            for (var z = 0; z < this.points.length; z++) {
                                
                                var series = this.points[z].series, // get all series
                                    indexPoint = this.points[z].point.index, // get index
                                    point = this.points[z].point, //get point
                                    str = '';
                                if (compare == "true" || compare == true)
                                    selectedMetric[index]=chartsData.selectedMetric_new.split(',');
                                // metricData += tooltipFormat(indexPoint, point, series, index, selectedMetricColumnlineSpecialCase.length ? selectedMetricColumnlineSpecialCase : selectedMetric, chartName, z, this.points.length, compare);
                                
                                let metricTouse = this.points[z]['series']['userOptions']['value']
                                let metricKeyValue = chartsData.data.metricKeyValue
                                if (period && metricKeyValue) {
                                    metricTouse = this.points[z]['series']['name']
                                    metricTouse = metricKeyValue[metricTouse]
                                } else {
                                    metricTouse = metricTouse;
                                }                 
                                let selectedMetricTemp = [];
                                selectedMetricTemp[index] = metricTouse ? [metricTouse] : selectedMetric[index];
                                
                                metricData += tooltipFormat(indexPoint, point, series, index, selectedMetricColumnlineSpecialCase.length ? selectedMetricColumnlineSpecialCase : selectedMetricTemp, chartName, z, this.points.length, compare, trend_hover_information, newMetricPossibleCombinations, that, );
                                toolTipData = metricData

                                if((compare==="true" || compare===true) && z>0){
                                    // var growthValue = ((this.points[z].y - this.points[z-1].y)/this.points[z-1].y)*100;
                                    var growthValue = ((this.points[z-1].y - this.points[z].y) / this.points[z].y) * 100;
                                    growthValue = delimitNumbersIndianFormat(growthValue,2,'');
                                    var spanClass = "text-red"
                                    if (growthValue[0] != '-' && growthValue != 'N.A.') {
                                        growthValue = '+' + growthValue;
                                        spanClass = "text-green";
                                    }
                                    growthValue = growthValue == 'N.A.'
                                        ? "&nbsp;<span class='" + spanClass + "'>(" + growthValue + ")</span>"
                                        : "&nbsp;<span class='" + spanClass + "'>(" + growthValue + "%)</span>";
                                    metricData += '<tr><th>Growth Rate for '+this.points[z].series.name+' : </th><td class="tableNumber">' + growthValue + '</td></tr>'
                                }
                            }
                        }

                        return ('' + metricData + '');
                    },
                    footerFormat: '</table>',
                    followPointer: false
                };
                if(data.yAxis){
                    newMetricPossibleCombinations = createCombination(chartsData.mainMetric ? chartsData.mainMetric : metricGlobal, metricFunction);
                    if(data.yAxis.labels){
                        var metricSelectedArrayYaxis=[];
                        jQuery(newMetricPossibleCombinations).each(function (innerIndex, val) {
                            if (val.label == data.yAxis.title.text) {
                                metricSelectedArrayYaxis[index] = val;
                                return false;
                            } else if (chartsData.data.shortNameKPI && chartsData.data.shortNameKPI[val.value] == data.yAxis.title.text) {
                                metricSelectedArrayYaxis[index] = val
                                return false;
                            }
                        });
                        if(metricSelectedArrayYaxis.length) {
                            data.yAxis.labels.formatter=function(){
                                var metricUnit=metricSelectedArrayYaxis[index].metricUnit?metricSelectedArrayYaxis[index].metricUnit:"";
                                if(this.chart.options.plotOptions.column.stacking=="percent")
                                    return number_shorten(this.value.toString(), 2, 'in') + " " + metricUnit;
                                else return number_shorten(this.value.toString(), metricSelectedArrayYaxis[index].roundOff ? metricSelectedArrayYaxis[index].roundOff : 0, metricSelectedArrayYaxis[index].numberShorten) + " " + metricUnit;
                            }
                        } else {
                            // For deep insight tooltip
                            var text = (data.yAxis.title.text).split(',');
                            text = text[1] ? text[1] : text[0]
                            extraParamsGlobel = extraParamsGlobel.length ? extraParamsGlobel : ((data.series && data.series[0] && data.series[0].data && data.series[0].data[0] && data.series[0].data[0].extraParam) ? (data.series[0].data[0].extraParam).split(',') : []);
                            var numberShorten;
                            var roundOff;
                            var metricUnit;
                            // metricName;metricUnit;metricPrefix;roundOff;numberShorten
                            extraParamsGlobel.map(function(value,index){
                                value = value.split(';');
                                if(value[0] == text) {
                                    numberShorten = value[4];
                                    roundOff = value[3];
                                    metricUnit = value[1];
                                }  
                            });                            
                            data.yAxis.labels.formatter=function(){
                                return number_shorten(this.value.toString(), roundOff, numberShorten) + " " + metricUnit
                            }
                        }
                        if(index>hideaxis && data.yAxis.labels)
                            data.yAxis.labels.enabled=false;
                    }
                    // For the charts having more than 1 values
                    if (data.yAxis.length > 1 || (Object.values(data.yAxis).length > 1 && data.chart.type == 'line')) {
                        // const absoluteMax = Math.max(
                        //     ...data.series.flatMap(series => series.data.map(Math.abs))
                        // );
                        // data.yAxis.map(axis => (axis.softMin = -absoluteMax, axis.softMax = absoluteMax))
                        selectedMetric[index].map(function (innerData, outerIndex) {
                            var metricSelectedArrayYaxisMul = [];
                            metricSelectedArrayYaxisMul[index] = [];
                            jQuery(newMetricPossibleCombinations).each(function (innerIndex, val) {
                                if (val.label == data.yAxis[outerIndex]?.title?.text) {
                                    metricSelectedArrayYaxisMul[index][outerIndex] = val;
                                    return false;
                                } else if (val.value == innerData) {                         //checked selectedMetric value in case of shortNames
                                    metricSelectedArrayYaxisMul[index][outerIndex] = val;
                                    return false;
                                }
                            });
                            if( data.yAxis[outerIndex] && data.yAxis[outerIndex].labels){
                           data.yAxis[outerIndex].labels.formatter = function(){
                                var metricUnit=metricSelectedArrayYaxisMul[index][outerIndex].metricUnit?metricSelectedArrayYaxisMul[index][outerIndex].metricUnit:"";
                                return number_shorten(this.value.toString(), metricSelectedArrayYaxisMul[index][outerIndex].roundOff ? metricSelectedArrayYaxisMul[index][outerIndex].roundOff : 0, metricSelectedArrayYaxisMul[index][outerIndex].numberShorten) + " " + metricUnit
                            }
                            if(index>hideaxis)
                                data.yAxis[outerIndex].labels.enabled=false;

                        }
                        })
                    }
                }
                if(data.xAxis){
                    if(data.xAxis.labels && data.xAxis.title && data.xAxis.title.text){
                        newMetricPossibleCombinations = createCombination(chartsData.mainMetric ? chartsData.mainMetric : metricGlobal, metricFunction);
                        var metricSelectedArrayXaxis=[];
                        jQuery(newMetricPossibleCombinations).each(function (innerIndex, val) {
                            if (val.label == data.xAxis.title.text) {
                                metricSelectedArrayXaxis[index] = val;
                                return false;
                            }
                        });
                        if(metricSelectedArrayXaxis.length) {
                            data.xAxis.labels.formatter=function(){
                                var metricUnit=metricSelectedArrayXaxis[index].metricUnit?metricSelectedArrayXaxis[index].metricUnit:"";
                                return number_shorten(this.value.toString(), 0, metricSelectedArrayXaxis[index].numberShorten) + " " + metricUnit
                            }
                        } else {
                            var text = data.xAxis.title.text ? (data.xAxis.title.text).split(',') : null;
                            text = text[1] ? text[1] : text[0]
                            extraParamsGlobel = extraParamsGlobel.length ? extraParamsGlobel : ((data.series && data.series[0] && data.series[0].data && data.series[0].data[0] && data.series[0].data[0].extraParam) ? (data.series[0].data[0].extraParam).split(',') : []);
                            var numberShorten;
                            var roundOff;
                            var metricUnit;
                            // metricName;metricUnit;metricPrefix;roundOff;numberShorten
                            extraParamsGlobel.map(function(value,index){
                                value = value.split(';');
                                if(value[0] == text) {
                                    numberShorten = value[4];                            
                                    roundOff = value[3];
                                    metricUnit = value[1];
                                }  
                            });                            
                            data.xAxis.labels.formatter=function(){
                                return number_shorten(this.value.toString(), roundOff, numberShorten) + " " + metricUnit
                            }
                        }
                        if(index>hideaxis && data.xAxis.labels)
                            data.xAxis.labels.enabled=false;
                    }
                }
                configData['y_axis'] = chartsData.chartDisp == 'Columnline' ? true : (yAxis != undefined && yAxis == 'false') ? false : configData['y_axis']

                // if(data.yAxis){
                //     data.yAxis.gridLineColor = "rgba(72, 94, 144, 0.16)";
                //     data.yAxis.gridLineWidth = "1px";
                //     data.yAxis.endOnTick = true;
                //     data.yAxis.startOnTick = true;
                // }

                // if(data.xAxis){
                //     data.xAxis.gridLineColor = "rgba(72, 94, 144, 0.16)";
                //     data.xAxis.gridLineWidth = "1px";
                //     data.xAxis.endOnTick = true;
                //     data.xAxis.startOnTick = true;
                // }

                if (chartsData.contextMenu) {
                    if (!data.plotOptions) {
                        data.plotOptions = {
                            series: {}
                        }
                    }
                    // if(chartName[index].toLowerCase() !== 'pie'){
                    //     data.xAxis ? data.xAxis.labels= {style:{color: 'grey',fontWeight: 'medium', fontSize: '11px'}} : null
                    // }
                    // if (chartName[index].toLowerCase() == 'bubble' && that.props.dataset && that.props.dataset.toolId == "128048"){
                    //     data.xAxis.plotLines=[{
                    //         color: 'black',
                    //         dashStyle: 'dot',
                    //         width: 2,
                    //         value: 45,
                    //         label: {
                    //             rotation: 0,
                    //             x: 15,
                    //             style: {
                    //                 fontStyle: 'italic'
                    //             },
                    //             text: ' sugar intake 50g/day'
                    //         },
                    //         zIndex: 3
                    //     }]
                    //     data.yAxis.plotLines=[{
                    //             color: 'black',
                    //             dashStyle: 'dot',
                    //             width: 2,
                    //             value: 50,
                    //             label: {
                    //                 align: 'right',
                    //                 style: {
                    //                     fontStyle: 'italic'
                    //                 },
                    //                 text: 'Safe sugar intake 50g/day',
                    //                 x: -10
                    //             },
                    //             zIndex: 3
                    //         }]
                           
                        
                    
                    // }
                    if(chartName[index].toLowerCase() == 'solidgauge' && data.series.length==1){
                        data.yAxis.max=100
                    }
                    data.plotOptions.series.cursor = 'pointer';
                    data.plotOptions.series.point = {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault()
                                // Enabled right click on dashboard charts
                                // if(highChartsDiv && chartName[index].toLowerCase() !== 'map' && chartName[index].toLowerCase() !== 'pie' && highChartsDiv.series[this.colorIndex])
                                if(highChartsDiv && chartName[index].toLowerCase() !== 'map' && chartName[index].toLowerCase() !== 'pie') {
                                    if(highChartsDiv.series && highChartsDiv.series[this.colorIndex]) {
                                        highChartsDiv.series[this.colorIndex].data[this.index].select();
                                    } else if(highChartsDiv[index] && highChartsDiv[index].series[this.colorIndex]) {
                                        highChartsDiv[index].series[this.colorIndex].data[this.index].select();
                                    }
                                }
                                if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') {
                                    var seriesName = getSeriesName(e, this);
                                    if (period == "hour" || period == "day name" || period == "day" || period == 'week' || period == 'month' || period == 'quarter' || period == 'year') 
                                        var timeSeries = 1;
                                    else 
                                        var timeSeries = 0;

                                    let insightSortOrder = extractAndSort(toolTipData)
                                    popOut(period, e, seriesName.name, drillGlobalObj, chart, timeSeries, seriesName.Date, chartName[index].toLowerCase(), chartsData, that.props, insightSortOrder);
                                } else {
                                    if (chartsData.is3D) 
                                        var targetName = this.name;
                                    else 
                                        var targetName = e.target.point.series.name;
                                    if (parseInt(targetName.split(" ")[1]).toString()!='NaN' || chartName[index].toLowerCase() == 'map') 
                                        targetName = (e.target.point.name) ? e.target.point.name : e.target.point.series.name;
                                    if(chartName[index].toLowerCase() == 'bullet' || chartName[index].toLowerCase() == 'bar bullet'){
                                        targetName = e.target.point.category;
                                    }
                                    if(chartName[index].toLowerCase() == 'map'){
                                        var chartObj = highChartsDiv;
                                        targetName = this.name ? this.name : this.options.name;
                                    }
                                    else var chartObj = chart;
                                    
                                    popOut(period, e, targetName, drillGlobalObj, chartObj, 0, null, chartName[index].toLowerCase(),chartsData, that.props);
                                }
                            }, 
                            click: function (e) {
                                if (jQuery(window).width() <= mobile_width || jQuery(window).width() <= tablet_width) {
                                    var chartObj = highChartsDiv;
                                    var targetName = e.target.point ? e.target.point.name : this.name;
                                    if (isThisPinboard()) {
                                        popOut(period, e, targetName, drillGlobalObj, chartObj[index], 0, null, chartName[index].toLowerCase(), chartsData, that.props);
                                    } else {
                                        popOut(period, e, targetName, drillGlobalObj, chartObj, 0, null, chartName[index].toLowerCase(), chartsData, that.props);
                                    }
                                }
                            },
                            dblclick: function(e){
                                if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') {
                                    var seriesName = getSeriesName(e, this);
                                    timeHandle(seriesName.name, seriesName.Date);
                                }
                                else if((drillGlobalObj.drillDown && drillGlobalObj.drillDown.obj) || chartsData.category=="Zip_Code"){
                                    if(highChartsDiv && chartName[index].toLowerCase() !== 'map' && chartName[index].toLowerCase() !== 'pie' && highChartsDiv.series[this.colorIndex])
                                        highChartsDiv.series[this.colorIndex].data[this.index].select();
                                    if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') {
                                        var seriesName = getSeriesName(e, this);
                                        if (period == "hour" || period == "day name" || period == "day" || period == 'week' || period == 'month' || period == 'quarter' || period == 'year') 
                                            var timeSeries = 1;
                                        else 
                                            var timeSeries = 0;
                                        drillFunction(seriesName.name,'drillDown','',seriesName.Date);
                                    } else {
                                        if (chartsData.is3D) 
                                            var targetName = this.name;
                                        else 
                                            var targetName = e.target.point.series.name;
                                        if (parseInt(targetName.split(" ")[1]).toString()!='NaN' || chartName[index].toLowerCase() == 'map') 
                                            targetName = (e.target.point.name) ? e.target.point.name : e.target.point.series.name;
                                        if(chartName[index].toLowerCase() == 'bullet' || chartName[index].toLowerCase() == 'bar bullet'){
                                            targetName = e.target.point.category;
                                        }
                                        if(chartName[index].toLowerCase() == 'map')
                                            targetName = this.name ? this.name : this.options.name;
                                        // else chartObj = chart;
                                        drillFunction(targetName,'drillDown','',null);
                                    }
                                }
                            }
                        }
                    };
                    // data.plotOptions.series.marker = {
                    //     enabled:chartName[index].toLowerCase() == 'bar'?false:  true,
                    //     states: {
                    //         hover: {
                    //             enabled: true
                    //         }
                    //     } ,       
                    //     lineWidth: 1
                    // };
                    // if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') {
                    //     data.plotOptions.series.point.events.click = function (e) {
                    //         var seriesName = getSeriesName(e, this);
                    //         timeHandle(seriesName.name, seriesName.Date);
                    //     }
                    // }
                }                
                // if (index == 1) { 
                    let fontSize = '12px'
                    var dataLabelsStatus=false;
                    // if(dataLabels=='1' && chartName[index].toLowerCase() !== 'scatter')
                    if(dataLabels=='1')
                        dataLabelsStatus = true;
                    if (!data.plotOptions) {
                        data.plotOptions.series.dataLabels.enabled = configData.data_labels;
                        data.plotOptions.series.dataLabels.style = {fontSize:fontSize};
                        // } else if (!data.plotOptions.series.dataLabels) {    // Commented by Anurag. Date: 25 Feb 2019.
                    } else {        // Always update the datalable flag of series based on user's current action whether to show labels or not
                        if(chartName[index].toLowerCase() == 'bar') {
                            data.plotOptions.series.dataLabels.enabled = configData.data_labels;
                            data.plotOptions.series.dataLabels.allowOverlap = configData.labelOverlap;
                            data.plotOptions.series.dataLabels.style = {fontSize:fontSize};
                            data.yAxis.title = false
                        } else {
                            data.plotOptions.series.dataLabels = {
                                enabled: configData.data_labels,
                                allowOverlap: configData.labelOverlap,
                                style: {
                                    fontSize: fontSize,
                                }
                            };
                            if(chartName[index].toLowerCase() == 'waterfall') {
                                data.plotOptions.series.dataLabels.inside= false
                                data.yAxis= {
                                    title: {
                                        enabled: false // This will hide the labels on the Y-axis
                                    }
                                }
                            }
                        }
                    }

                    //condition to disabled shared tooltip for charts on Dashboard Page
                    if (index && typeof index === "string"){
                        data.tooltip.shared = true;
                    }
                    
                    // if(NoLegendCharts.indexOf(chartName[index])!=-1) {
                    let NoLegendCharts = ["line","column","bar"];
                    // data.y_axis=configData['y_axis'] = false                 
                    if(chartsData.period=="" && chartsData.selectedMetric.split(",").length==1 && NoLegendCharts.indexOf(chartName[index].toLowerCase())!=-1) {
                        data.legend = configData['legend'] = false
                    }

                    if ((chartName[index].toLowerCase() === "line" || chartName[index].toLowerCase() == "column" || chartName[index].toLowerCase() === "bubble" || chartName[index].toLowerCase() == "scatter" || chartName[index].toLowerCase() == "bar bullet" || chartName[index].toLowerCase() == "bar") && typeof index === "string") {
                        // { "legend": true, "x_axis_label": false, "y_axis_label": false, "gridline": false, "x_axis": true, "y_axis": true, "data_labels": true }
                        if (data.legend) {
                            if (Boolean(chartsData.period && chartsData.period != ""))
                                data.legend.enabled = configData ? (configData['legend'] ? true : false) : true;
                            else if (chartName[index].toLowerCase() == "bar bullet" || chartName[index].toLowerCase() == "bar") {
                                data.legend.enabled = configData ? (configData['legend'] ? true : false) : true;

                            }
                        }
                        else {
                            var enable_status = { "enabled": configData ? (configData['legend'] ? true : false) : true };
                            data.legend = enable_status;
                        }
                        data.plotOptions.series.dataLabels.enabled = configData ? (configData['data_labels'] ? true : false) : true;

                        data.chart.marginTop = 30;
                        data.chart.marginRight = 15;
                        if (configData) {
                            if (!configData['gridlines']) {
                                if(data.yAxis) {
                                    data.yAxis.gridLineWidth = 0;
                                    data.yAxis.minorGridLineWidth = 0;
                                }
                            }
                        }
                        // data.yAxis.visible = configData ? (configData['y_axis'] ? true : false) : true;
                        // data.xAxis.visible = configData ? (configData['x_axis'] ? true : false) : true;
                        // data.xAxis.labels = { "enabled": configData ? (configData['x_axis_label'] ? true : false) : true };
                        // data.yAxis.labels = { "enabled": configData ? (configData['y_axis_label'] ? true : false) : true };

                    }
                    
                    if (chartName[index].toLowerCase() == 'bubble' || chartName[index].toLowerCase() == 'scatter' || chartName[index].toLowerCase()=="treemap") {
                    data.plotOptions.series.dataLabels.enabled = configData.data_labels
                        data.plotOptions.series.dataLabels={
                            formatter: function () {
                                var metricToPrintData = refineData(chartName[index].toLowerCase() == "treemap" ? selectedMetric[index][0] : selectedMetric[index], metric[index], metricFunction);
                                if (metricToPrintData.metricPrefix === "true")
                                    var newDataFull = number_shorten(this?.point?.value.toString(), metricToPrintData.roundOff, metricToPrintData.numberShorten);
                                else
                                    var newDataFull = number_shorten(chartName[index].toLowerCase() == "treemap" ? this.point?.colorValue : this?.point?.value, metricToPrintData.roundOff, metricToPrintData.numberShorten);
                                return `${this?.key}<br>${newDataFull}${metricToPrintData?.metricUnitHTML ? metricToPrintData?.metricUnitHTML : metricToPrintData?.metricUnit ? metricToPrintData?.metricUnit : ""}`;
                            }
                        }
                    }
                    else if (chartName[index].toLowerCase() == 'pie') {
                        // pie chart configuration starts
                        if (chartsData.index && chartsData['dashboard_config']) {
                            data.plotOptions.series.dataLabels.enabled = configData ? (configData['data_labels'] ? true : false) : true;
                            data.plotOptions.series.showInLegend = screen_width<500 && getParameters('dashboard_id')? false: configData ? (configData['legend'] ? true : false) : true;
                            data.plotOptions.series.size = screen_width <= mobile_width ? 150 : '100%';
                            data.legend = {
                                align: 'right',
                                verticalAlign: 'top',
                                layout: 'vertical',
                                x: 0,
                                y: 100
                            }
                        }
                        // data.legend.floating = true
                        // pie chart configuration ends
                        data.series[0].dataLabels = {
                            formatter: function () {
                                let isPercentageShareMetric = selectedMetric[index][0].split(";")[1] == "percentageshare" ? true : selectedMetric[index][0]?.split(";")[1]?.substring(2)==="percentageshare";
                                var metricToPrintData=refineData(selectedMetric[index], metric[index], metricFunction);
                                if(metricToPrintData.metricPrefix==="true")
                                    var newDataFull = (metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+" "+number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                else var newDataFull = number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                return this.key + ": " + newDataFull + " (" + delimitNumbersIndianFormat(this.percentage, parseInt(2)) + " %)";
                            }
                        }
                    }else if (chartName[index].toLowerCase() == 'map') {
                        // data.plotOptions.series.dataLabels.enabled = configData ? (configData['data_labels'] ? true : false) : true;
                        data.plotOptions.series.dataLabels = {
                            formatter: function(){
                                var metricToPrintData=refineData(selectedMetric[index], metric[index], metricFunction);
                                if(this.point.value){
                                    if(metricToPrintData.metricPrefix==="true")
                                        var newDataFull = (metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+" "+number_shorten(this.point.value.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                    else var newDataFull = number_shorten(this.point.value.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                    return newDataFull;
                                }
                            }
                        }
                    } else if (chartName[index].toLowerCase() == 'funnel') {
                        data.plotOptions.series.dataLabels.enabled = true;
                        data.series[0].dataLabels = {
                            formatter: function () {
                                var metricToPrintData=refineData(selectedMetric[index], metric[index], metricFunction);
                                if(metricToPrintData.metricPrefix==="true")
                                    var newDataFull = (metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+" "+number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                else var newDataFull = number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                return this.key + ": " + newDataFull + " (" + delimitNumbersIndianFormat(this.percentage, parseInt(2)) + "%)"; // if number than apply default rounding
                                // "{point.y:." + innerData.roundOff + "f}"// if number than apply default rounding
                            }
                        }
                        data.plotOptions.series.center = ['30%', '50%'];
                        data.plotOptions.series.width = "60%";
                        data.plotOptions.series.neckWidth = "23.5%";
                        data.plotOptions.series.neckHeight = "35%";
                    } else {
                        // Handle Deep Insight metrics unit here
                        if(compare=="true" || compare==true)
                            selectedMetric[index]=chartsData.selectedMetric_new.split(',');
                        var metricToPrintData = refineData(selectedMetric[index][0], metric[index], metricFunction,newMetricPossibleCombinations);
                        let indexToUse = null
                        let datalableData = []
                        data.series.map(function (innerData, mainIndex) {
                                if(data.series[mainIndex].dataLabels) {
                                    indexToUse = mainIndex;    
                                    datalableData = data.series[mainIndex].dataLabels;    
                                }                                
                                data.series[mainIndex].dataLabels = {
                                    // formatter: function () {
                                    //     if(selectedMetric[index].length>1){
                                    //         metricToPrintData=refineData(selectedMetric[index][mainIndex], metric[index], metricFunction);
                                    //     }
                                    //     if (this.percentage) {
                                    //         var newDataFull = delimitNumbersIndianFormat(this.y, parseInt(2));
                                    //         var percentageData = delimitNumbersIndianFormat(this.percentage, parseInt(2));
                                    //         if(metricToPrintData.metricPrefix==="true")
                                    //             var newDataFull = percentageData + "% ("+(metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+" "+number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten) + " )";
                                    //         else var newDataFull = percentageData +"% ("+number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten) + (metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+ " )";
                                    //     } else {
                                    //         var newDataFull = delimitNumbersIndianFormat(this.y, parseInt(2));
                                    //         if(metricToPrintData.metricPrefix==="true")
                                    //             var newDataFull = (metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""))+" "+number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten);
                                    //         else var newDataFull = number_shorten(this.y.toString(), metricToPrintData.roundOff,metricToPrintData.numberShorten)+" "+(metricToPrintData.metricUnitHTML?metricToPrintData.metricUnitHTML:(metricToPrintData.metricUnit?metricToPrintData.metricUnit:""));
                                    //     }
                                    //     return newDataFull;
                                    // }
                                    formatter: function () {
                                        let thisY = this.y || this.y === 0 ? this.y : this.point.value
                                        let seriesArr = data.series[0].data

                                        if (dataLabelConfig == "alternate") {
                                            if (this.point.index % 2 == 0) {
                                                thisY = thisY
                                            } else thisY = ''
                                        } else if (dataLabelConfig == "firstLast") {
                                            if (this.point.index == 0 || this.point.index == seriesArr.length - 1) {
                                                thisY = thisY
                                            } else thisY = ''
                                        } else thisY = thisY

                                        if (selectedMetric[index].length > 1) {
                                            metricToPrintData = refineData(selectedMetric[index][mainIndex], metric[index], metricFunction, newMetricPossibleCombinations);
                                        }
                                        var unit = thisY && metricToPrintData?.metricUnitHTML ? metricToPrintData?.metricUnitHTML : (thisY && metricToPrintData?.metricUnit ? metricToPrintData?.metricUnit : "");
                                        var yAxisNumber = number_shorten(thisY.toString(), metricToPrintData?.roundOff, (metricToPrintData?.value?.includes('growth') || metricToPrintData?.value?.includes('share') ? "" : metricToPrintData?.numberShorten));
                                        let chartCategory;
                                        try {
                                            chartCategory = getParameters('chartCat') ? decodeURIComponent(getParameters('chartCat'))?.toLowerCase() : that.props?.chartDisp?.toLowerCase();
                                        } catch {
                                            chartCategory = null; // Handle invalid URI encoding gracefully
                                        }
                                        if (
                                            metricToPrintData?.value &&
                                            (metricToPrintData.value.includes('percentageshare') ||
                                                metricToPrintData?.metricUnit == '%') &&
                                            (chartCategory === 'column stacked' || chartCategory === 'column stacked normal')
                                        ) {
                                            DontShowPercentageInColumnStacked = 1
                                        }
                                        let dontShowPercentage = DontShowPercentageInColumnStacked === 1 || DontShowPercentageInColumnStacked === "1" ? true : false;
                                        // Don't show % share in Column stacked
                                        if (!dontShowPercentage && this.percentage) {
                                            var newDataFull = delimitNumbersIndianFormat(thisY, parseInt(2));
                                            var percentageData = delimitNumbersIndianFormat(this.percentage, parseInt(1));
                                            if (metricToPrintData?.metricPrefix === "true")
                                                var newDataFull = (chartCategory === 'column stacked' || chartCategory === 'column stacked normal') ? (unit) + " " + yAxisNumber + " " + "(" + percentageData + "%" + ")" : percentageData + "% " + "(" + (unit) + " " + yAxisNumber + ")";
                                            else var newDataFull = yAxisNumber + (unit) + " " + "(" + percentageData + "%" + ")";
                                        } else {
                                            var newDataFull = delimitNumbersIndianFormat(thisY, parseInt(2));
                                            if (metricToPrintData?.metricPrefix === "true")
                                                var newDataFull = (unit) + " " + yAxisNumber;
                                            else var newDataFull = yAxisNumber + " " + (unit);
                                        }
                                        return newDataFull;
                                    }
                                }
                                // if(that.props.dashboard && that.props.waterfallPointWidth && chartName[index].toLowerCase() == 'waterfall') {
                                if(that.props.waterfallPointWidth && chartName[index].toLowerCase() == 'waterfall') {
                                    data.series[mainIndex].pointWidth = 30
                                }
                            });
                        if(chartsData.chartDisp == 'Columnline' && indexToUse) {
                            data.series[indexToUse].dataLabels = Object.assign(data.series[indexToUse].dataLabels, datalableData);
                        }
                    }
                // }
                if(chartName[index].toLowerCase() !== 'map'){
                    data.chart.events = {
                        load: function () {
                            chart = this;
                            if(chartName[index]?.toLowerCase() == 'treemap'){
                            chart.container.addEventListener('contextmenu', function (e) {
                                e.preventDefault(); // Prevent default right-click menu
                                if (chartsData.is3D) 
                                        var targetName = this.name;
                                    else 
                                        var targetName = e.target.point.series.name;
                                    if (parseInt(targetName.split(" ")[1]).toString()!='NaN' || chartName[index].toLowerCase() == 'map') 
                                        targetName = (e.target.point.name) ? e.target.point.name : e.target.point.series.name;
                                    if(chartName[index].toLowerCase() == 'bullet' || chartName[index].toLowerCase() == 'bar bullet'){
                                        targetName = e.target.point.category;
                                    }
                                    if(chartName[index].toLowerCase() == 'map'){
                                        var chartObj = highChartsDiv;
                                        targetName = this.name ? this.name : this.options.name;
                                    }
                                    else var chartObj = chart;
                                    
                                    popOut(period, e, targetName, drillGlobalObj, chartObj, 0, null, chartName[index].toLowerCase(),chartsData, that.props);
                            });
                        }

                    }
                }
                }else{
                    var latlng_data=null;
                    if(chartsData.mapType=="world"){
                        var mapData = 'custom/world';
                    }else if(chartsData.mapType=="us" || chartsData.mapType=="india"){
                        var breakUp_data = chartsData.breakUp && chartsData.breakUp.length>1 ? chartsData.breakUp.split(",") : [];
                        var temp_property={"property":[],'value':[]};
                        breakUp_data.map(function(value,index){
                            temp_property["property"].push(value.split(";")[1]);
                            temp_property["value"].push(value.split(";")[0]);
                        })
                        var state_index=temp_property['property'].indexOf("State");
                        var city_index=temp_property['property'].indexOf("City");
                        var zip_index=temp_property['property'].indexOf("Zip_Code");
                        if((chartsData.category.toLowerCase()==="state" || chartsData.category.toLowerCase()==="detected_state") && chartsData.mapType==="us")
                            var mapData = 'countries/us/us-all';
                        else if((chartsData.category.toLowerCase()==="state" || chartsData.category.toLowerCase()==="detected_state") && chartsData.mapType==="india")
                            var mapData = 'countries/in/custom/in-all-disputed';
                        // else if((chartsData.category==="City" || chartsData.category==="Zip_Code") && (state_index>-1 || city_index>-1 || zip_index>-1)){
                        else if(chartsData.category.toLowerCase()==="branch_name" || chartsData.category.toLowerCase()==="branch_sol_id" || chartsData.category.toLowerCase()==="city" || chartsData.category.toLowerCase()==="zip_code" || chartsData.category.toLowerCase()==="pincode" || chartsData.category.toLowerCase()==="pt_partner_pin_code"){
                            data.series.shift();
                            data.series.shift();
                            var finalData_maps = [];
                            var color_array_to_print=[];
                            data.series.map(function(innerData,index){
                                color_array_to_print.push(innerData.color);
                                if(finalData_maps.length==0)
                                    finalData_maps=innerData.data;
                                else jQuery.merge(finalData_maps,innerData.data);
                            })
                            var latlng_data=null
                            if(data.chart)
                                if(typeof data.chart.event==="string")
                                    var latlng_data=JSON.parse(data.chart.event);
                            initMap(finalData_maps,chartDivId,drillGlobalObj,chartsData,latlng_data,color_array_to_print);
                            return null;
                            /*highchcarts code for city & pincode
                            var state_name=temp_property['value'][state_index];
                            state_name=state_name.replace(" ","_");
                            var mapData = 'countries/us/us-'+state_name+'-all';
                            end of highchcarts code for city & pincode*/
                        }
                        else var mapData = 'countries/us/us-all-all';
                    }else var mapData = 'countries/in/custom/in-all-disputed';
                    if(data.series){
                        if(chartsData.category==="City"){
                            data.series[0].data=Highcharts.geojson(Highcharts.maps[mapData], 'mapline');
                        }
                        var events=[];
                        if(latlng_data){
                            var events={
                                load:function(){
                                    var pos = this.fromLatLonToPoint({ lat: latlng_data.latitude, lon: latlng_data.longitude });
                                    this.mapZoom(0.1, pos.x, pos.y);
                                }
                            }
                        }
                        data.chart={
                            map:mapData,events
                        }
                    }
                }
                data.exporting.enabled=false;

                if(chartName[index].toLowerCase() !== 'area'){
                    data.plotOptions.area = {
                        stacking: 'normal',
                        lineColor: 'white',
                        lineWidth: 1,
                        marker: {
                            enabled:false,
                            lineWidth: 1,
                            lineColor: 'white'
                        }
                    }
                }
                
                data.exporting.filename=`${chartsData.detail1}`;
                data.boost = { useGPUTranslations: true };
                // Set chart styles based on configData
                // set scatter chart's legend to false to hide series 1, series 2
                // data.legend = chartsData.chartCat == "Scatter" && chartsData.analysis == "true" && index == 1 ? { enabled: true } : { enabled: configData.legend }
                
                data.legend = chartsData.chartCat == "Scatter" ? { enabled: false } : { enabled: configData.legend }

                if(chartsData?.selectedMetricDisp?.length > 1 &&  chartsData.chartCat != "Scatter" &&  chartsData.chartCat != "Bubble" ) {
                    data.legend = { enabled: true };
                }
                
                
                if (data.xAxis) {
                    if (data.xAxis.length) {
                        for (let i = 0; i < data.xAxis.length; i++) {
                            data.xAxis[i].labels = { ...data.xAxis[i].labels, enabled: configData.x_axis_label }
                            data.xAxis[i].title = { ...data.xAxis[i].title, enabled: configData.x_axis_label }
                            data.xAxis[i].gridLineWidth=1;
                        }
                    } else {
                        if(data.xAxis.labels || data.xAxis.categories)
                            data.xAxis.labels = { ...data.xAxis.labels, enabled: configData.x_axis_label };
                        if(data.xAxis.title || data.xAxis.categories)
                            data.xAxis.title = { ...data.xAxis.title, enabled: configData.x_axis_label };
                        // data.xAxis.gridLineWidth=1;

                    }
                }
                if (data.yAxis) {
                    if (data.yAxis.length) {
                        for (let i = 0; i < data.yAxis.length; i++) {
                            data.yAxis[i].labels = { ...data.yAxis[i].labels, enabled: configData.y_axis }
                            data.yAxis[i].title = { ...data.yAxis[i].title, enabled: configData.y_axis_label }
                            if(configData.gridline==true){
                            data.yAxis[i].gridLineWidth=1;
                            }else{
                                data.yAxis[i].gridLineWidth=0;
                            }
                            // data.yAxis[i].plotLines=[{
                            //     color: 'black',
                            //     dashStyle: 'dot',
                            //     width: 2,
                            //     value: 65,
                            //     label: {
                            //         rotation: 0,
                            //         y: 15,
                            //         style: {
                            //             fontStyle: 'italic'
                            //         },
                            //         text: 'Safe fat intake 65g/day'
                            //     },
                            //     zIndex: 3
                            // }]

                        }
                    } else {
                        if (data.yAxis.labels)
                            data.yAxis.labels = { ...data.yAxis.labels, enabled: configData.y_axis };
                        if (data.yAxis.title)
                            data.yAxis.title = { ...data.yAxis.title, enabled: configData.y_axis_label };
                        if (configData.gridline == true) {
                            data.yAxis.gridLineWidth = 1;
                        } else {
                            data.yAxis.gridLineWidth = 0;
                        }
                        // data.yAxis.plotLines= [{
                        //     color: 'black',
                        //     dashStyle: 'dot',
                        //     width: 2,
                        //     value: 50,
                        //     label: {
                        //         align: 'right',
                        //         style: {
                        //             fontStyle: 'italic'
                        //         },
                        //         text: 'Safe sugar intake 50g/day',
                        //         x: -10
                        //     },
                        //     zIndex: 3
                        // }]
                    }
                }
                if(chartName[index].toLowerCase() == 'solidgauge'){
                    data.pane.background.map(function(innerData,index){
                                           data.pane.background[index]["backgroundColor"] = isNaN(innerData["backgroundColor"]) ? innerData["backgroundColor"] : Highcharts.color(Highcharts.getOptions().colors[innerData["backgroundColor"]]) .setOpacity(0.3).get()
                                            })
                                            data.series.map(function(innerData,index){
                                                innerData["data"][0]['color'] = isNaN(innerData["data"][0]['color']) ? innerData["data"][0]['color'] : Highcharts.getOptions().colors[innerData["data"][0]['color']];
                                            })
                    
                    // data.pane.background.map(function(innerData,index){
                    //    data.pane={
                    //     startAngle: 0,
                    //     endAngle: 360,
                    //     background: [{ // Track for Move
                    //         outerRadius: '112%',
                    //         innerRadius: '88%',
                    //         backgroundColor: Highcharts.color(Highcharts.getOptions().colors[0])
                    //             .setOpacity(0.3)
                    //             .get(),
                    //         borderWidth: 0
                    //     }]
                    // }, 
                    //     data.pane.background[index]["backgroundColor"] : Highcharts.color(Highcharts.getOptions().colors[   data.pane.background[index]["backgroundColor"]]) .setOpacity(0.3).get()
                    // })
                        // data.pane.background[0].backgroundColor =     data.pane.background[0].backgroundColor 
                    //commented code of two circles
                    // data.series.map(function(innerData,index){
                    //     innerData["data"][0]['color'] = isNaN(    innerDaya["data"][0]['color']) ? innerData["data"][0]['color'] : Highcharts.getOptions().colors[innerData["data"][0]['color']];
                    // })  
                                        //   data.series = [{
                                        //     name: 'Move',
                                        //     data: [{
                                        //         color: Highcharts.getOptions().colors[0],
                                        //         radius: '112%',
                                        //         innerRadius: '88%',
                                        //         y: 80
                                        //     }]
                                        // }, ]
                                        //   ? data.series[0]["data"][0]['color'] : Highcharts.getOptions().colors[    data.series[0]["data"][0]['color']];
                    data.plotOptions.solidgauge = {
                        rounded: true,
                        dataLabels: {
                            enabled: false
                        },
                        linecap: 'round',
                        stickyTracking: false,
                    }
                }
                // data.plotOptions.series.dataLabels = {...data.plotOptions.series.dataLabels,enabled:configData.data_labels}
                
                data.plotOptions.series = {
                    ...data.plotOptions.series,
                    allowPointSelect: false,
                    states: {
                        select: {
                            color: null,     // Prevent grey/dark highlight
                            borderColor: null, // Remove selection border
                            halo: {
                                size: 0     // No halo effect
                            }
                        }
                    }
                }
                data.plotOptions.series.marker = {
                    enabled: true,
                    lineWidth: 0,
                    states: {
                        hover: {
                            enabled: chartsData?.chartDisp?.toLowerCase() == "line" || chartsData?.chartDisp?.toLowerCase() == "area" ? true : false,     // Removes hover color/border
                            radiusPlus: 0       // Prevent marker size increase
                        },
                        select: {
                            enabled: false,     // Disables selection styling
                            radius: null,
                            lineColor: null,
                            fillColor: null
                        }
                    }
                }
                if (index == 1) {
                    if(data.series){
                        if(chartName[index].toLowerCase() !== 'map'){
                            data.chart.height = 400;
                            that.setState({highChartsState:true})
                            highChartsDiv = Highcharts.chart(chartDivId, data);
                        }else {
                            data.mapNavigation.enabled = false;
                            that.setState({highChartsState:true})
                            mapChartFix(data, chartDivId, index);
                        }
                    }
                } else {
                    if(jQuery.isArray(highChartsDiv)){
                        // data.chart.height = 400;
                        // data.chart.height = (chartsData.deepInsightStyle || chartsData.spikeStyle) ? 280 : 400;
                        data.chart.height = (chartsData.deepInsightStyle || chartsData.spikeStyle) ? 300 : jQuery(jQuery('#container' + index).parents()[3]).height() - 90;
                        // // data.exporting.enabled = false;
                        data.exporting.enabled = false;
                        data.title.text = null;
                        if (chartName[index].toLowerCase() !== 'map')
                            highChartsDiv[index] = Highcharts.chart(chartDivId, data);
                        else {
                            data.mapNavigation.enabled = false;
                            mapChartFix(data, chartDivId, index);
                        }
                    } else {
                        data.chart.height = (chartsData.deepInsightStyle || chartsData.spikeStyle) ? 300 : 400;
                        if (chartName[index].toLowerCase() !== 'map')
                            Highcharts.chart(chartDivId, data);
                        else {
                            data.mapNavigation.enabled = false;
                            mapChartFix(data, chartDivId, index);
                        }
                    }
                }
            });
        }
        // console.log(data);
        var tempCheck = true;
        var menuItems = Highcharts.getOptions().exporting.buttons.contextButton.menuItems;
        // Highcharts.getOptions().exporting.buttons.contextButton.menuItems.map(function (innerData) {
        //     if (innerData.text == "Export as CSV") {
        //         tempCheck = false;
        //     }
        //     // if (innerData == "downloadCSV") {
        //     //     tempCheck = false;
        //     // }
        // });
        Highcharts.getOptions().exporting.buttons.contextButton.menuItems = menuItems.filter((innerData,i)=>{
            // viewData
            // the export menu for the chart excludes the below options,to add them,remove the necessary name from the  excludeOptionsArray
            let excludeOptionsArray = ["printChart", "downloadCSV","openInCloud"];

            return !excludeOptionsArray.includes(innerData);
        })

        Highcharts.getOptions().exporting.buttons.contextButton.menuItems.map(function (innerData) {
            if (innerData.text == "Export as CSV") {
                tempCheck = false;
            }
  
        })
        if (chartsData.is3D && index == 1) {
            // Add mouse events for rotation
            jQuery(highChartsDiv.container)
                .on('mousedown.hc touchstart.hc', function (eStart) {
                    eStart = highChartsDiv
                        .pointer
                        .normalize(eStart);

                    var posX = eStart.chartX,
                        posY = eStart.chartY,
                        alpha = highChartsDiv.options.chart.options3d.alpha,
                        beta = highChartsDiv.options.chart.options3d.beta,
                        newAlpha,
                        newBeta,
                        sensitivity = 5; // lower is more sensitive

                    jQuery(document).on({
                        'mousemove.hc touchmove.hc': function (e) {
                            // Run beta
                            e = highChartsDiv
                                .pointer
                                .normalize(e);
                            newBeta = beta + (posX - e.chartX) / sensitivity;
                            highChartsDiv.options.chart.options3d.beta = newBeta;

                            // Run alpha
                            newAlpha = alpha + (e.chartY - posY) / sensitivity;
                            highChartsDiv.options.chart.options3d.alpha = newAlpha;

                            highChartsDiv.redraw(false);
                        },
                        'mouseup touchend': function () {
                            jQuery(document).off('.hc');
                        }
                    });
                });
        }
        if (tempCheck) 
            Highcharts.getOptions().exporting.buttons.contextButton.menuItems.push({
                text: 'Export as CSV',
                onclick: function () {
                    downloadFunction();
                }
            });
    }
    drillFunction(){
        // let valueDemo;
        // if (event == 'drillAcross' || event == 'drillAcrossTime') {
        //     valueDemo = [];
        //     drillGlobalObj['drillAcross'].map(function(data) {
        //         if (value == data.value) {
        //             valueDemo.obj = data;
        //             valueDemo.value = data.value;
        //         }
        //     })
        // } else if (event == 'segment') {
        //     valueDemo = null;
        // } else if (event == 'deepInsight') {
        //     valueDemo = null;
        // } else if (event == 'chart') {
        //     valueDemo = value;
        // } else if (event == 'extract') {
        //     valueDemo = value;
        // } else valueDemo = drillGlobalObj[event];
    }
    // popOut(period, e, targetName, drillObjMain, chart, timeSeries, date, chartName){
    //     var $property = this.state.category;
    //     var that = this;
    //     var isSegmentSelected = false;
    //     var extract='';
    //     $property = $property.split(',');
    //     $property.map(function (value) {
    //         var $prop = value.split(';');
    //         $prop.map(function (val) {
    //             if (decodeURIComponent(val) == targetName) {
    //                 if ($prop[1] == 'custom_segment') { // check if clicked value is segment
    //                     isSegmentSelected = true;
    //                     return false;
    //                 }
    //             }
    //         });
    //     });
        
    //     let insightTargetName = targetName;
    //     // if selected_metric is greater than 2 and it is not bubble or scatter or treemap than change the targetname
    //     if(this.state.selectedMetricDisp.length>1 && ["bubble",'scatter','treemap'].indexOf(chartName)==-1 && e.target.point)
    //         targetName=e.target.point.category;
        
    //     if (isSegmentSelected) // don't open context menu if clicked value if segment
    //         return;
        
    //     var ContextMenuData = [];
        
    //     if(chartName!='map') {
    //         drillObjMain.drillAcross.map(function (data) {
    //             // "${targetName}","drillAcross","${data.value}","${date}")'>
    //             ContextMenuData.push(<a className="across child dropdown-item" key={data.label} onclick={drillFunction(targetName,"drillAcross",data.value,date)}>{data.label}</a>);
    //         });
    //     }
        
    //     var contextMenu = <ul className="dropdown-menu" id="parentUl" style={{width:"230px",maxHeight:"200px",overflow:"auto"}}>
    //             <a className="main dropdown-item"><i className="glyphicon glyphicon-remove"></i>Close</a>
    //             {ContextMenuData}
    //         </ul>;
    //     setTimeout(startAccordian, 200);
        
    //     var newX, newY;
    //     if (e.pageX < 220) { // clicked on extreme left
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 200;
    //         }
    //     } else if (chart.containerWidth - e.pageX < 250) { // extreme right
    //         if (e.pageY > 320) { // towared bottom
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 160;
    //         }
    //     } else { // middle cases
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 170;
    //         }
    //     }

    //     chart.renderer.label(ReactDOMServer.renderToStaticMarkup(contextMenu), newX, newY, 'rect', e.pageX, e.pageY, true).addClass('contMenu').attr({zIndex: 10}).add();
    //     jQuery('#parentUl').show();
    // }
    render() {
        var pinDash = null;
        var main_chart_style = { width: '100%', padding: "0px 0px 0px 0px" };
        if (this.props.index) {
            var chartDivId = 'container' + this.props.index;
        } else {
            var chartDivId = 'container';
        }
        if (this.props.index == 1 && this.props && !this.props.isSideInsight)
            pinDash = <a
                href='#'
                onClick={pinHandleFunction}
                className='pull-right'
                style={{
                    fontSize: "20px"
                }}>
                <i
                    className="fa fa-thumb-tack"
                    title="Pin to Dashboard"
                    data-toggle="tooltip"
                    data-placement="bottom"></i>
            </a>;
        var insightData = null;
        if (this.state.showInsight) {
            insightData = <FraudInsight security={this.state.securityGiven} startTime={this.state.startTime} endTime={this.state.endTime} />;
        }
        if (this.props.spikeStyle) {
            if (this.props.spikeStyleWidth) {
                spikeStyle = {
                    margin: '0 auto 3.7%',
                    width: this.props.spikeStyleWidth
                };
            }
            var chartDiv = <div id={chartDivId} style={spikeStyle}></div>
        } else if (this.props.deepInsightStyle) {
            var chartDiv = <div id={chartDivId} style={deepInsightStyle}></div>
        } else if (this.props.spikeNewPageStyle) {
            var chartDiv = <div id={chartDivId} style={spikeNewPageStyle}></div>
        } else {
            if (this.props.index == 1)
                main_chart_style = { width: '100%', padding: "15px auto" };
            var style_chart = null;
            /* old/previously commented code now uncommented for probable solution of height issue in case of google maps */
            if (this.props.chartCat && this.props.chartCat.toLowerCase() === 'map')
                style_chart = { "height": "500px" };
            var chartDiv = <div id={chartDivId} ></div>
        }

        if (this.props.title) {
            var chartTitle = <div className="card-header pd-2">{this.props.title}</div>
        }
        if (this.props.final_details == "Show Filter Information") {
            var show_filter_information = <a data-toggle="tooltip" data-placement="left" title={this.props.final_details_hover} data-html="true" className="card-footer pd-10 mg-b-0" >{this.props.final_details}</a>
        }
        else if (this.props.final_details != '') {
            var show_filter_information = <p className="card-footer pd-10 mg-b-0">{this.props.final_details}</p>
        }
        if (this.props.isSideInsight) {
            var show_filter_information = ''
        }

        var class_card_name="card";
        if(this.props.index>1){
            class_card_name = "";

            let displayValue = this.props.report_type && this.props.report_type == 'static' ? 'show' : 'none'
            // displayValue = this.props.dashboard && this.props.dashboard_config && this.props.dashboard_config['information'] ? 'show' : 'none';

            show_filter_information = <p className="card-footer pd-10 mg-b-0 dashboard_footer_class slideInUp animated faster" id={"dashboard_footer_"+this.props.index} style={{ position: 'absolute', bottom: '0', maxHeight: '100px', backgroundColor: 'white', margin: '0px', width: "100%", display: displayValue }}>{this.props.dashboard && this.props.dashboardDateInfo ? this.props.dashboardDateInfo : this.props.final_details}</p>
        }
        else {
            resetFilterGo();
            resetAppliedFilterFlag();
        }        
        resetFilterGo();
        resetAppliedFilterFlag();
        return (
            <div className={class_card_name}>
                {this.props.ExportComponentVar}
                {insightData}
                {chartTitle}
                {this.props.isSideInsight || this.props.dashboard ? chartDiv : (this.state.highChartsState != true ? <LoadingComponent messages={["Loading your Chart!"]} /> : chartDiv)}
                {/* {chartDiv} */}
                {this.props.index === 1 ? show_filter_information : show_filter_information}
            </div> 
        );
    }
}

export default ChartComponent;

function getSeriesName(e, obj) {
    var date, seriesName;
    var point = e.point;
    point = point ? point : e.point;
    if (point) {
        // date = point.name;
        date = fyMonth>1 ? point.name - 1 : point.name;

        date = isNaN(date)?point.name:date;

        // seriesName = e.target.point.series.name;
        seriesName = obj.series.name;
    } else {
        date = fyMonth>1 ? obj.name - 1 : obj.name;
        seriesName = obj.series.name;
    }
    return { 'name': seriesName, "Date": date };
}

function singleData(value) {
    value = value.split(',');
    for (i = 0; i < metric.length; i++) {
        for (j = 0; j < metric.length; j++) {
            if (metric[i].value == value[i]) 
                value[i] = metric[j].label;
            }
        }
    return value;
}

function refineChartData(value) {
    value
        .forEach(function (data, key) {
            if (key == 0) {
                sampleData = data;
                for (i = 0; i < sampleData.length; i++) {
                    metric
                        .forEach(function (data) {
                            if (sampleData[i] == data.value) 
                                sampleData[i] = data.label;
                            }
                        );
                }
            } else {
                sampleData = data;
                metric.forEach(function (data) {
                    if (sampleData[0] == data.value) 
                        sampleData[0] = data.label;
                    }
                );
            }
        });
    return value;
}

function tooltipFormat(indexPoint, point, series, index, selectedMetric, chartName, pointIndex, seriesLength, compare, trend_hover_information,newMetricPossibleCombinations,props,dynKey=null) {
    if(props.props.selectedMetricDisp == undefined || props.props.selectedMetricDisp == null  ){
    if (props?.props?.selectedMetric && props?.props?.selectedMetric?.length > 0) {
      var selectedMetricDisp = metricDataToDisp(props?.props?.mainMetric,props?.props?.metricFunction, props?.props?.selectedMetric);
    }
}
    let newprops = props?.props
    let chartCategory;
    const parsedData = JSON.parse(props.props?.dataset?.userDBSetting?.[0]?.information || '{}');
    

    try {
        chartCategory = getParameters('chartCat')? decodeURIComponent(getParameters('chartCat'))?.toLowerCase(): props?.props?.chartDisp?.toLowerCase() ;
    } catch {
        chartCategory = null ; // Handle invalid URI encoding gracefully
    }
    let granularity =
        (chartCategory === 'column stacked' || chartCategory === 'column stacked normal' ? "" :
            ((getParameters("period") != null || newprops.period != null || getParameters("period") != undefined || newprops.period != undefined)
                ? ((getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'week') ? "WoW: " :
                    ((getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'quarter') ? "QoQ: " :
                        ((getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'year') ? "YoY: " :
                            ((getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'month') ? "MoM: " :
                                ((getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'date' ||
                                    (getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'day' || (getParameters("period")?.toLowerCase() ?? newprops.period.toLowerCase()) === 'dayname') ? "DoD: " : ""
                : ""))

    let tooltipCharts = ['bar', 'column', 'line', 'line1', 'area', 'column stacked', 'column stacked normal', 'column stack', 'column stack normal', 'columnline', 'barline']
    let tooltipCharts1 = ['bar', 'column', 'line', 'line1', 'area']
    let tooltipChartsBreakup = ['pie', 'funnel', 'bullet', 'bar bullet', 'solidgauge']

    var metricData = "", axis, demo, spanClass = '', newSelectedMetric = [], absolute, sign, span;
    if (seriesLength > 1 && selectedMetric[index].length > 1) {
        newSelectedMetric[index] = [selectedMetric[index][pointIndex]];
    } else newSelectedMetric[index] = selectedMetric[index];

    let lowerChartName = chartName[index].toLowerCase();

    if (lowerChartName == "waterfall" && selectedMetric[index].length > 1) {
        newSelectedMetric[index] = [selectedMetric[index][indexPoint]];
    }

    if (lowerChartName == "solidgauge" && selectedMetric[index].length > 1) {
        newSelectedMetric[index] = [selectedMetric[index][selectedMetric[index].length - series.index - 1]];
    }

    for (var i = 0; i < newSelectedMetric[index].length; i++) {
        if (lowerChartName == 'scatter' || lowerChartName == 'bubble')
            axis = i == 0
                ? point.x
                : (i == 1
                    ? point.y
                    : point.z);
        else if (tooltipCharts.indexOf(lowerChartName) != -1) {
            axis = point.y ? point.y : point.value;
        }
        else if (tooltipCharts1.indexOf(lowerChartName) != -1) {
            axis = point.y;
        }
        else if (tooltipChartsBreakup.indexOf(lowerChartName) != -1)
            axis = point.y;
        else if (lowerChartName == 'treemap') {
            if (i == 0)
                axis = point.colorValue;
            else axis = point.value;
        }
        else if (lowerChartName == 'map') {
            if (newSelectedMetric[index].length > 1) {
                let newI = i ? i : "";
                axis = point['value' + newI];
            } else axis = point['value'];
        }
        axis = axis ? axis : point.y
        var innerData = refineData(newSelectedMetric[index][i], metric[index], metricFunction,newMetricPossibleCombinations);
        let filteredData;
        let dynamicKey;
        if (newprops?.data?.trend_tooltip_growth_metrics?.result != null && newprops?.data?.trend_tooltip_growth_metrics != undefined ) {
                dynamicKey = props?.props?.selectedMetricDisp?.length > 1 || selectedMetricDisp?.length > 1 ? series?.name : newprops?.data?.information?.metric[0];
            }
        if (newprops?.data?.trend_tooltip_growth_metrics?.result != null && newprops?.data?.trend_tooltip_growth_metrics != undefined) {
            let lyKey = (newprops?.data?.information?.property && getParameters('property') != "null") ? `${series.name}_${point.name}` : `_${point.name}`;
            let result = newprops?.data?.trend_tooltip_growth_metrics?.result;

            let resultArray;
            if (result?.[dynamicKey]) {
                resultArray = result?.[dynamicKey]
            }
            if (resultArray) {
                filteredData = Object.fromEntries(
                    Object.entries(resultArray).filter(([key, value]) => key?.includes(lyKey))
                );
            } else {
                filteredData = {};
            }
        } else {
            filteredData = {}; // Handle case where result is null
        }

        let metricValue = Object.values(selectedMetric || {}).some(
            (metricArray) => metricArray?.[0]?.includes('growth') || metricArray?.[0]?.includes('percentageshare') || innerData?.metricUnit == '%'
          );
        // innerData = changeNumberFormat(innerData,index==1?propertyMain:propertyArray[index].property)
        if ((chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1') && compare !== "true" && compare !== true) {
            if (newprops?.data?.trend_tooltip_growth_metrics != null && newprops?.data?.trend_tooltip_growth_metrics != undefined) {
                let value = Object.values(filteredData).map(value => value ?? "null");
                if (value?.length > 0) {
                    if (value?.[0] != 'N.A.') {
                        if ((parseFloat(value[0]) >= 0 && (props?.props?.selectedMetricDisp?.[0].isPositive == '1' || selectedMetricDisp[0]?.isPositive=='1')) ||
                            (parseFloat(value[0]) <= 0 && (props?.props?.selectedMetricDisp?.[0]?.isPositive == '0' || selectedMetricDisp?.[0]?.isPositive=='0'))) {
                            sign = '';
                            spanClass = "green";
                        } else if ((parseFloat(value[0]) < 0 && props?.props?.selectedMetricDisp?.[0]?.isPositive == '1' || selectedMetricDisp?.[0]?.isPositive == '1') || (parseFloat(value[0]) > 0 && props?.props?.selectedMetricDisp?.[0]?.isPositive == '0' || selectedMetricDisp?.[0]?.isPositive == '0')) {
                            spanClass = "red";
                        }
                    } else if (value[0] == 'null') {
                        spanClass = "";
                    }
                } else {
                    if (value?.length==0) {
                       spanClass='';
                    }
                }
            }
            if (series?.data[indexPoint - 1] && !series?.stackedYData) {
                if (point?.y && series?.data[indexPoint - 1].y) {
                    absolute = (point.y - series.data[indexPoint - 1].y)
                    demo = trend_hover_information == 'variance' ? absolute : (absolute / Math.abs(series?.data[indexPoint - 1].y)) * 100;
                }
                else if (point?.y) {
                    demo = 'N.A.';
                    absolute = 'N.A.';
                } else if (series?.data[indexPoint - 1].y) {
                    absolute = (0 - series.data[indexPoint - 1].y)
                    demo = trend_hover_information == 'variance' ? absolute : (absolute / Math.abs(series.data[indexPoint - 1].y)) * 100;
                }
                else {
                    demo = 0;
                }

                // demo = point.growth;
                demo = demo == 'N.A.' || trend_hover_information == 'variance' ? demo : delimitNumbersIndianFormat(demo, 2, "");
                if(newprops?.data?.trend_tooltip_growth_metrics == null || newprops?.data?.trend_tooltip_growth_metrics == undefined){
                if (demo.toString().charAt(0) != '-' && demo != 'N.A.') {
                    sign = '+';
                    demo = trend_hover_information == 'variance' ? demo : ('+' + demo);
                    // spanClass = "text-green";
                    spanClass = "green";
                } else {
                    sign = '';
                    // spanClass = "text-red";
                    spanClass = "red";
                }
            }
                let unitToUse = demo == 'N.A.' || trend_hover_information == 'variance' ? '' : '%';
                if (trend_hover_information == 'variance') {
                    span = "&nbsp;<span style='color:" + spanClass + "'>(";
                } else {
                    demo = metricValue
                    ? ""
                        : `&nbsp;<span style='color:${spanClass}'>` +
                        (newprops.data.trend_tooltip_growth_metrics !== null && newprops.data.trend_tooltip_growth_metrics !== undefined 
                            ? (newprops?.data?.trend_tooltip_growth_metrics?.result[dynamicKey] ?
                                 `(GOLY: ${Object.values(filteredData).length > 0 ?
                                (Object.values(filteredData).length > 1
                                    && Object.values(filteredData)?.[pointIndex] != null && Object.values(filteredData)?.[pointIndex] !== "null"
                                    ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)?.[pointIndex],
                                        2
                                    )} %`
                                    : Object.values(filteredData)?.[0] != null && Object.values(filteredData)?.[0] != undefined ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)[0],
                                        2
                                    )} %` : "-")
                                : Object.values(filteredData).length == 0 ? "-" : ( Object.values(filteredData).length > 1 && Object.values(filteredData)?.[pointIndex] == null || Object.values(filteredData)?.[pointIndex] == "null" ? '-' : ( Object.values(filteredData).length == 1 && Object.values(filteredData)?.[0] == null || Object.values(filteredData)?.[0] == "null" ? '-' : ""))
                            })`:"")
                            : parsedData?.trend_tooltip_growth?"": `(${granularity}${demo} ${unitToUse})` 
                        ) +
                        `</span>`;
                    ;

                }
                // ? "&nbsp;<span class='" + spanClass + "'>(" + demo + ")</span>"
                // : "&nbsp;<span class='" + spanClass + "'>(" + demo + "%)</span>";
            } else if (chartName[index].toLowerCase() == 'line' && series.stackedYData) {
                // let growthaValue = delimitNumbersIndianFormat(point.percentage,2)
                // spanClass = growthaValue < 0 ? "red" : "green"
                // demo = "&nbsp;<span style='color:" + spanClass + "'>(" + growthaValue + "%)</span>";
                if (trend_hover_information == 'variance') {
                    span = "&nbsp;<span style='color:" + spanClass + "'>(";
                } else {
                    demo = metricValue
                    ? ""
                    : 
                         `&nbsp;<span style='color:${spanClass}'>` +
                        (newprops?.data?.trend_tooltip_growth_metrics !== null &&    newprops?.data?.trend_tooltip_growth_metrics !== undefined && newprops.data.trend_tooltip_growth_metrics.result[dynamicKey]
                            ? (newprops.data.trend_tooltip_growth_metrics.result[dynamicKey] ?  `(GOLY: ${Object.values(filteredData).length > 0 ?
                                (Object.values(filteredData).length > 1
                                    && Object.values(filteredData)?.[pointIndex] != null && Object.values(filteredData)?.[pointIndex] !== "null"
                                    ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)?.[pointIndex],
                                        2
                                    )} %`
                                    : Object.values(filteredData)?.[0] != null && Object.values(filteredData)?.[0] != undefined ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)[0],
                                        2
                                    )} %` : "-")
                                : Object.values(filteredData).length == 0 ? "-" : Object.values(filteredData)?.[pointIndex] == null || Object.values(filteredData)?.[pointIndex] == "null" ? '-' : ""
                            })`:"")
                            : parsedData?.trend_tooltip_growth? "" : `(${granularity}${delimitNumbersIndianFormat(point.percentage, 1)}%)`
                        ) +
                        `</span>`;

                }
            } else
                demo = metricValue ? "" : newprops?.data?.trend_tooltip_growth_metrics !== null && newprops?.data?.trend_tooltip_growth_metrics !== undefined ? `&nbsp;<span style='color:${spanClass}'>` +
                    (newprops?.data?.trend_tooltip_growth_metrics !== null && newprops?.data?.trend_tooltip_growth_metrics !== undefined 
                        ? (newprops.data.trend_tooltip_growth_metrics.result[dynamicKey] ? `(GOLY: ${Object.values(filteredData).length > 0 ?
                            (Object.values(filteredData).length > 1
                                && Object.values(filteredData)?.[pointIndex] != null && Object.values(filteredData)?.[pointIndex] !== "null"
                                ? `${delimitNumbersIndianFormat(
                                    Object.values(filteredData)?.[pointIndex],
                                    2
                                )} %`
                                :Object.values(filteredData)?.[0] != null && Object.values(filteredData)?.[0] != undefined ? `${delimitNumbersIndianFormat(
                                    Object.values(filteredData)[0],
                                    2
                                )} %` : "-")
                            : Object.values(filteredData).length == 0 ? "-" : Object.values(filteredData)?.[pointIndex] == null || Object.values(filteredData)?.[pointIndex] == "null" ? '-' : ""
                        })`:"")
                        : ''
                    ) + `</span>`
                    : ""
            axis = axis ? axis : 0
            if (innerData) {
                if (trend_hover_information == 'variance') {
                
                    if (innerData?.metricPrefix == 'true')
                        metricData += '<tr><th style="color:' + (newprops?.data?.trend_tooltip_growth_metrics != null && newprops?.data?.trend_tooltip_growth_metrics != undefined ? spanClass : point.color)  + '">' + series.name + ':</th><td class="tableNumber">' +  (innerData.metricUnit==null?"":innerData.metricUnit) + ' ' 
                            + number_shorten(axis, innerData.roundOff, (innerData.value.includes('growth') || innerData.value.includes('share')) ? "" : innerData.numberShorten) + '' +
                            (newprops?.data?.trend_tooltip_growth_metrics?.result != undefined 
                            ? (newprops.data.trend_tooltip_growth_metrics.result[dynamicKey] ? `(GOLY: ${Object.values(filteredData).length > 0 ?
                                (Object.values(filteredData).length > 1
                                    && Object.values(filteredData)?.[pointIndex] != null && Object.values(filteredData)?.[pointIndex] != "null"
                                    ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)?.[pointIndex],
                                        2
                                    )} %`
                                    : Object.values(filteredData)?.[0] != null && Object.values(filteredData)?.[0] != undefined ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)[0],
                                        2
                                    )} %` : "-")
                                    : "0 %" // Fallback for empty filteredData
                            })`:"")
                            : 
                                  ((innerData.value?.includes('growth') || innerData.value?.includes('percentageshare') || innerData?.metricUnit == ' %' ? "" : absolute ? span + granularity + (innerData.metricUnit == null ? "" : innerData.metricUnit) + ' ' + sign + number_shorten(absolute, innerData.roundOff, (innerData.value?.includes('growth') || innerData.value?.includes('share')) ? "" : innerData.numberShorten) + ')' : ''))
                              + '</td></tr>');
                    else if (innerData?.metricPrefix == 'false')
                        metricData += '<tr><th style="color:' + (newprops?.data?.trend_tooltip_growth_metrics != null && newprops?.data?.trend_tooltip_growth_metrics != undefined ? spanClass : point.color) + '">' + series.name + ':</th><td class="tableNumber">' + number_shorten(axis, innerData.roundOff, innerData.value.includes('growth') || innerData.value.includes('share')) + '' + (innerData.metricUnit == null ? "" : innerData.metricUnit) + ' ' +
                            (newprops?.data?.trend_tooltip_growth_metrics?.result != undefined  
                            ? (newprops.data.trend_tooltip_growth_metrics.result[dynamicKey] ? `(GOLY: ${Object.values(filteredData).length > 0 ?
                                (Object.values(filteredData).length > 1
                                    && Object.values(filteredData)?.[pointIndex] != null && Object.values(filteredData)?.[pointIndex] !== "null"
                                    ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)?.[pointIndex],
                                        2
                                    )} %`
                                    : Object.values(filteredData)?.[0] != null && Object.values(filteredData)?.[0] != undefined ? `${delimitNumbersIndianFormat(
                                        Object.values(filteredData)[0],
                                        2
                                    )} %` : "-")
                                : " 0%" // Fallback for empty filteredData
                            })`:"")
                            :
                            ((innerData.value.includes('growth') || innerData.value.includes('percentageshare') || innerData?.metricUnit == '%' ? "" : absolute ? span + granularity + sign + number_shorten(absolute, innerData.roundOff, (innerData.value.includes('growth') || innerData.value.includes('share')) ? "" : innerData.numberShorten) + '' + (innerData.metricUnit == null ? "" : innerData.metricUnit) + ')' : ''))
                            + '</td></tr>');
                    else {
                        metricData += '<tr><th style="color:' + point.color + '">' + series.name + ':</th><td class="tableNumber">' + ((innerData.value.includes('growth') || innerData.value.includes('share') ? number_shorten(axis, innerData.roundOff, (innerData.value.includes('growth') || innerData.value.includes('share')) ? "" : innerData.numberShorten) + (innerData.metricUnit == null ? innerData.metricUnit : "") : number_shorten(axis, innerData.roundOff, innerData.numberShorten))) + ''
                            + (innerData.value.includes('growth') || innerData.value.includes('percentageshare') || innerData?.metricUnit == '%' ? "" : absolute ? span + granularity + sign + number_shorten(absolute, innerData.roundOff, innerData.numberShorten) + ')' : '') + '</td></tr>';
                    }

                }
                 else {
                    if (innerData?.metricPrefix === 'true') {
                        // Case: Metric prefix before the number
                        metricData += `<tr>
                            <th style="color:${point.color}">${series.name}:</th>
                            <td class="tableNumber">
                                ${innerData.metricUnit ? innerData.metricUnit + ' ' : ''}${number_shorten(axis, innerData.roundOff, innerData.value.includes('growth') || innerData.value.includes('share') ? "" : innerData.numberShorten)}${demo}
                            </td>
                        </tr>`;
                    } else if (innerData?.metricPrefix === 'false') {
                        // Case: Metric prefix after the number
                        metricData += `<tr>
                            <th style="color:${point.color}">${series.name}:</th>
                            <td class="tableNumber">
                                ${number_shorten(axis, innerData.roundOff, innerData.value.includes('growth') || innerData.value.includes('share') ? "" : innerData.numberShorten)}${innerData.metricUnit ? ' ' + innerData.metricUnit : ''} ${demo}
                            </td>
                        </tr>`;
                    } else {
                        // Case: Default handling when metricPrefix is neither 'true' nor 'false'
                        let isGrowthOrShare = innerData.value.includes('growth') || innerData.value.includes('share');
                        let shortNumber = number_shorten(axis, innerData.roundOff, isGrowthOrShare ? "" : innerData.numberShorten);
                        let metricUnit = innerData.metricUnit ? innerData.metricUnit : '';

                        metricData += `<tr>
                            <th style="color:${point.color}">${series.name}:</th>
                            <td class="tableNumber">
                                ${shortNumber + metricUnit }${demo}
                            </td>
                        </tr>`;
                    }
                }
            }
            else
                metricData += '<tr><th style="color:' + point.color + '">' + series.name + ':</th><td class="tableNumber">' + 1 + '' + demo + '</td></tr>';
        }
        else {
            if (innerData && !point.extraParam) {
                if (chartName[index].toLowerCase() == 'line' || (seriesLength > 1 && chartName[index].toLowerCase() == 'bar'))
                    var temp_label = series.name;
                // else if (innerData.shortName) {
                //     let shortNameObj = JSON.parse(innerData.shortName)
                //     var temp_label = shortNameObj[innerData.value.split(';')[1]]
                //     temp_label = temp_label ? temp_label : innerData.label
                // } 
                else var temp_label = innerData.label;
                if (innerData?.metricPrefix === 'true') {
                    // Case 1: Metric prefix before the number
                    metricData += `<tr>
                        <th style="color:${point.color}">${temp_label}:</th>
                        <td class="tableNumber">${innerData.metricUnit ? innerData.metricUnit + ' ' : ''}${number_shorten(axis, innerData.roundOff, innerData.value.includes('growth') || innerData.value.includes('share') ? "" : innerData.numberShorten)}</td>
                    </tr>`;
                } else if (innerData?.metricPrefix === 'false') {
                    // Case 2: Metric prefix after the number
                    metricData += `<tr>
                        <th style="color:${point.color}">${temp_label}:</th>
                        <td class="tableNumber">${number_shorten(axis, innerData.roundOff, innerData.value.includes('growth') || innerData.value.includes('share') ? "" : innerData.numberShorten)}${innerData.metricUnit ? ' ' + innerData.metricUnit : ''}</td>
                    </tr>`;
                } else {
                    // Case 3: Default handling (e.g., stacked data or fallback)
                    let isGrowthOrShare = innerData.value?.includes('growth') || innerData.value?.includes('share');
                    let shortNumber = number_shorten(axis, innerData.roundOff, isGrowthOrShare ? "" : innerData.numberShorten);
                    let metricUnit = innerData.metricUnit ? innerData.metricUnit : '';
                
                    if (series.stackedYData) {
                        // Handle stacked data case
                        metricData += `<tr>
                            <th style="color:${point.color}">${temp_label}:</th>
                            <td class="tableNumber">${shortNumber}${metricUnit}&nbsp;<span></span></td>
                        </tr>`;
                    } else {
                        // Default fallback case
                        metricData += `<tr>
                            <th style="color:${point.color}">${temp_label}:</th>
                            <td class="tableNumber">${shortNumber}${metricUnit}</td>
                        </tr>`;
                    }
                }
            }
            else
                //if extraparams added to show on chart then this case isused
                // metricName;metricUnit;metricPrefix;roundOff;numberShorten
                if (point.extraParam) {
                    var splitData = point
                        .extraParam
                        .split(",");
                    //multiple extra parameter passed "," so need to explode to convert it to array
                    splitData.map(function (innerData, index) {
                        var innerDataData = innerData.split(";");
                        //condition sent ";" 1 is name 2 is unit 3 is prefix position
                        if (index == 0) {
                            // if index is one than actual y is used to print
                            var valueToShow = //else other extraparam name is used to pick value from array
                                'y';
                        } else
                            var valueToShow = innerDataData[0];
                        if (innerDataData[2]) {
                            if (point[valueToShow] == 'N.A.')
                                metricData += '<tr><th style="color:' + point.color + '">' + innerDataData[0] + ':</th><td class="tableNumber">' + point[valueToShow] + '</td></tr>';
                            else {
                                if (innerDataData[2] == 'true')
                                    metricData += '<tr><th style="color:' + point.color + '">' + innerDataData[0] + ':</th><td class="tableNumber">' + innerDataData[1] + '' + number_shorten(point[valueToShow], innerDataData[3], innerDataData[4]) + '</td></tr>';
                                else
                                    metricData += '<tr><th style="color:' + point.color + '">' + innerDataData[0] + ':</th><td class="tableNumber">' + number_shorten(point[valueToShow], innerDataData[3], "") + '' + innerDataData[1] + '</td></tr>';
                            }
                        } else if (innerDataData[2] === false)
                            metricData += '<tr><th style="color:' + point.color + '">' + innerDataData[0] + ':</th><td class="tableNumber">' + number_shorten(point[valueToShow], innerDataData[3], innerDataData[4]) + '' + innerDataData[1] + '</td></tr>';
                        else
                            metricData += '<tr><th style="color:' + point.color + '">' + innerDataData[0] + ':</th><td class="tableNumber">' + number_shorten(point[valueToShow], innerDataData[3], "") + '</td></tr>';
                    }
                    )
                } else
                    metricData += innerData ? '<tr colo><th style="color:' + point.color + '">' + innerData?.label + ':</th><td class="tableNumber">' + 1 + '</td></tr>' : '';
        }
        if (chartName[index].toLowerCase() == 'line' || chartName[index].toLowerCase() == 'line1')
            break;
    }
    return metricData;
}

function startAccordian() {
    var acc = document.getElementsByClassName("main_new");
    var i;
    if (acc.length > 0)
        for (i = 0; i < acc.length; i++) {
            acc[i].onclick = function (e) {
                if (e.target.textContent == 'Breakdown by') {
                    jQuery(".main").hide();
                    jQuery(".child.across").css("display", "block");
                } else if (e.target.textContent == 'Breakdown by (Time)') {
                    jQuery(".main").hide();
                    jQuery(".child.acrossTime").css("display", "block");
                } else if (e.target.textContent == 'Switch Chart') {
                    jQuery(".main_new").hide();
                    jQuery(".child.chart").css("display", "block");
                } else if (e.target.textContent == 'Extract') {
                    jQuery(".main").hide();
                    jQuery(".child.extract").css("display", "block");
                }
            }
        }
}

function isThisPinboard() {
    return window.location.pathname.includes("/pinboard");
}

function popOut(period, e, targetName, drillObjMain, chart, timeSeries, date, chartName, chartsData, componentData, insightSortOrder) {
    jQuery('.contMenu').remove();
    var $property = checkParamValueInUrl('?property', true); // get property value from url
    var isSegmentSelected = false;
    var extract='';
    var contextMenu = null;
    $property = $property.split(',');
    $property.map(function (value) {
        var $prop = value.split(';');
        $prop.map(function (val) {
            if (decodeURIComponent(val) == targetName) {
                if ($prop[1] == 'custom_segment') { // check if clicked value is segment
                    isSegmentSelected = true;
                    return false;
                }
            }
        });
    });
    
    let insightTargetName = targetName;
    // if selected_metric is greater than 2 and it is not bubble or scatter or treemap than change the targetname
    // Commented by Anurag on 10 Feb 2022. It was giving issues on Column line chart with multuple KPIs and non-aggregated timeseries. Was not capturing Metric (getting date only) when right clicked.
    if(chartsData.selectedMetricDisp && chartsData.selectedMetricDisp.length>1 && ["bubble",'scatter','treemap'].indexOf(chartName)==-1 && e.target.point)
        targetName=e.target.point.category;
        // targetName=`${e.target.point.category};${targetName}`;
    if (isSegmentSelected) // don't open context menu if clicked value if segment
        return;
    var ContextMenuData = '',
        drillUpHTML,
        drillDownHTML = '';
    
    let chartsInfo = {
        'chart': true,
        'breakUp': chartsData.breakUp,
        'chartCat': chartsData.chartCat,
        'chartDisp': chartsData.chartDisp,
        "period":period,
        'include':chartsData.include,
        'exclude':chartsData.exclude
    }
    filterData = {
        'chart': true,
        'chartCat': chartsData?.chartCat,
        "property": chartsData?.property,
        'chartDisp': chartsData?.chartDisp,
        "propertyDisp": chartsData?.propertyDisp,
        "period": chartsData?.period,
        "breakUp": chartsData?.breakUp,
        "breakUpDisp": chartsData?.breakUpDisp,
        "include": chartsData?.include,
        "includeDisp": chartsData?.includeDisp,
        "exclude": chartsData?.exclude,
        "excludeDisp": chartsData?.excludeDisp,
        "selectedProperty": chartsData?.category,
        "selectedMetric": chartsData?.selectedMetric,
        "selectedMetricDisp": chartsData?.selectedMetricDisp,
        'startDate': chartsData?.startDate,
        'endDate': chartsData?.endDate,
        'startDateDisp': chartsData?.startDateDisp,
        'endDateDisp': chartsData?.endDateDisp,
    }

    if(chartName!='map') {
        drillObjMain.drillAcross.map(function (data) {
            ContextMenuData += `<a class="child across dropdown-item" onclick='drillFunction("${targetName}","drillAcross","${data.value}","${date}","${chartsData.selectedMetric}","${chartsData.category}",filterData)'>${data.label}</a>`;
        });
        drillObjMain.drillAcross.map(function (data) {
            ContextMenuData += `<a class="child acrossTime dropdown-item" onclick='drillFunction("${targetName}","drillAcrossTime","${data.value}","${date}",filterData)'>${data.label}</a>`;
        });
    }

    

    var trendButton = `<a class="main dropdown-item" onclick="drillFunction('${targetName}','chart','Line','${date}', '${chartsData.selectedMetric}', '${chartsData.category}', filterData)">View Trend</a>`;

    // switch chart commented
    chartArray.map(function (data) {
        ContextMenuData += '<a class="child chart" onclick="drillFunction(\'' + targetName + '\',\'chart\',\'' + data + '\',\'' + date + '\')">' + data + '</a>';
    });
    // end of switch chart commented

    if (history.length) {
        var empty = '';
        drillUpHTML = `<a class="main dropdown-item" onclick="drillFunction('${targetName}','back','${empty}','${date}',filterData)"><i class="glyphicon glyphicon-menu-left"></i>Back</a>`;
    } else 
        drillUpHTML = '';
    if (drillObjMain && drillObjMain.drillDown && drillObjMain.drillDown.value) {
        empty = '';
        drillDownHTML = `<a class="main dropdown-item" onclick="drillFunction('${targetName}','drillDown','${empty}','${date}',filterData)"><i class="glyphicon glyphicon-menu-down"></i>Drill Down</a>`;
    } else 
        drillDownHTML = '';
        
    var segment = '';
    var dateTime = "";
    var deepInsight = "";
    pinboardComponentData = componentData
        
    if (period != 'hour' && period != 'day name') {                
        dateTime = `<a class='main dropdown-item' onclick="event.preventDefault();eventHandleInsight('${date}','${targetName}','insight', '${chartsData.category}', '${chartsData.selectedMetric}', '${insightSortOrder}')"><i class="fa fa-lightbulb-o"></i>Auto Analysis</a>`;
        // deepInsight = `<a class='main dropdown-item' onclick="event.preventDefault();eventHandleInsight('${date}','${targetName}','deepInsight',  '${chartsData.category}', '${chartsData.selectedMetric}')"><i class="fa fa-lightbulb-o"></i>Root Cause Analysis</a>`;
    }        

    if(chartName!='map') {
        var drillAcrossHTML = `<a class="main dropdown-item main_new"><i class="glyphicon glyphicon-random"></i>Breakdown by<i class="fa fa-angle-double-right pull-right"></i></a>`;
        var drillAcrossTimeHTML = '';
    }
    else {
        var drillAcrossHTML = '';
        var drillAcrossTimeHTML = '';
    }
    
    if(!checkIfFeatureApplicable('Drill Across')) {
        drillUpHTML = drillDownHTML = drillAcrossHTML = drillAcrossTimeHTML = ''
    }

    if(!checkIfFeatureApplicable('Insight')) {
        dateTime = '';
    }

    if(!checkIfFeatureApplicable('Root Cause Analysis')) {
        deepInsight = ''
    }

    // if (chartsData.dashboard) {
    //     drillAcrossHTML = "";
    //     drillDownHTML = "";
    // }

    // Switch chart option: Add after drill across in below contextMenu
    if (isThisPinboard()) {
        contextMenu = '<ul class="dropdown-menu" id="parentUl" style="cursor:pointer;width:230px;max-height:160px;overflow:auto">' +
            '<a class="main dropdown-item"  onclick="jQuery(\'.contMenu\').remove()"><i class="glyphicon glyphicon-remove"></i>Close</a>'
            + drillDownHTML + drillAcrossHTML + drillAcrossTimeHTML + dateTime + '' + deepInsight + '' + trendButton + '' + extract + '' +
            '<a class="child chart across acrossTime extract dropdown-item" onclick="jQuery(\'.main\').toggle();jQuery(\'.child\').hide();"><i class="glyphicon glyphicon-menu-left"></i>Back</a>' +
            ContextMenuData + segment +
            '</ul>';
    } else {
        contextMenu = '<ul class="dropdown-menu " id="parentUl" style="cursor:pointer;width:230px;max-height:210px;overflow:auto">' +
            '<a class="main dropdown-item"  onclick="jQuery(\'.contMenu\').remove()"><i class="glyphicon glyphicon-remove"></i>Close</a>'
            + drillUpHTML + '' + drillDownHTML + drillAcrossHTML + drillAcrossTimeHTML + dateTime + '' + deepInsight + '' + trendButton + '' + extract + '' +
            '<a class="child chart across acrossTime extract dropdown-item" onclick="jQuery(\'.main\').toggle();jQuery(\'.child\').hide();"><i class="glyphicon glyphicon-menu-left"></i>Back</a>' +
            ContextMenuData + segment +
            '</ul>';
    }
    setTimeout(startAccordian, 200);

    
    // NOTE: e.pageX - NUM NUM is high :  contextMenu will go to left side NUM is
    // low : contentMenu will go to right side

    // NOTE: e.pageY - NUM NUM is high : ContextMenu will go to up NUM is low :
    // ContextMenu will go to low
    // <-----------------Prev version----------------------->    
    // var newX,
    //     newY;
    // if(isThisPinboard()) {
    //     if (e.pageX < 220) { // clicked on extreme left
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 200;
    //         }
    //     } else if (chart.containerWidth - e.pageX < 250) { // extreme right
    //         if (e.pageY > 320) { // towared bottom
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 160;
    //         }
    //     } else { // middle cases
    //         if (e.pageY > 320) { // toward bottom
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 300;
    //         } else {
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 170;
    //         }
    //     }
    //     newX = Math.abs(newX);
    //     newY = Math.abs(newY);
    // } else {
    //     if (e.pageX < 220) { // clicked on extreme left
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 200;
    //         }
    //     } else if (chart.containerWidth - e.pageX < 250) { // extreme right
    //         if (e.pageY > 320) { // towared bottom
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 160;
    //         }
    //     } else { // middle cases
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 170;
    //         }
    //     }
    // }
    // if(isThisPinboard()) {
    //     // let sizeY = Math.round(chart.plotSizeY);
    //     // if(sizeY > 500) sizeY -= chart.plotSizeY/2;
    //     // else if(sizeY > 200) sizeY -= 100;
    //     // newY = sizeY;
    //     // newX = chart.mouseDownX;
    //     // newY = chart.mouseDownY;
    //     if (chart.mouseDownX < 220) { // clicked on extreme left
    //         if (chart.mouseDownY > 320) { // towared bottom
    //             newX = chart.mouseDownX - 100;
    //             newY = chart.mouseDownY - 280;
    //         } else {
    //             newX = chart.mouseDownX - 100;
    //             newY = chart.mouseDownY - 200;
    //         }
    //     } else if (chart.containerWidth - chart.mouseDownX < 250) { // extreme right
    //         if (chart.mouseDownY > 320) { // towared bottom
    //             newX = chart.containerWidth - 250;
    //             newY = chart.mouseDownY - 280;
    //         } else {
    //             newX = chart.containerWidth - 250;
    //             newY = chart.mouseDownY - 160;
    //         }
    //     } else { // middle cases
    //         if (chart.mouseDownY > 320) { // towared bottom
    //             newX = chart.mouseDownX - 90;
    //             newY = chart.mouseDownY - 280;
    //         } else {
    //             newX = chart.mouseDownX - 90;
    //             newY = chart.mouseDownY - 170;
    //         }
    //     }
    //     newX = Math.abs(newX);
    //     newY = Math.abs(newY);
    // }else {
    //     if (e.pageX < 220) { // clicked on extreme left
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 100;
    //             newY = e.pageY - 200;
    //         }
    //     } else if (chart.containerWidth - e.pageX < 250) { // extreme right
    //         if (e.pageY > 320) { // towared bottom
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = chart.containerWidth - 250;
    //             newY = e.pageY - 160;
    //         }
    //     } else { // middle cases
    //         if (e.pageY > 320) { // towared bottom
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 280;
    //         } else {
    //             newX = e.pageX - 90;
    //             newY = e.pageY - 170;
    //         }
    //     }
    // }
    // chart
    //     .renderer
    //     .label(contextMenu, newX, newY, 'rect', e.pageX, e.pageY, true)
    //     .addClass('contMenu')
    //     .attr({zIndex: 10})
    //     .add();
    // <-----------------Prev version-----------------------> 


    // <-----------------New version----------------------->
    const containerRect = chart.container.getBoundingClientRect();

    // Calculate available space within the container
    const containerWidth = containerRect.width;
    const containerHeight = containerRect.height;
    
    // Calculate the proposed position
    let newX = null;
    let newY = null;
    // if (e?.touches[0]?.pageX && e?.touches[0]?.pageY) {
    //     newX = e?.touches[0]?.pageX - containerRect.left;
    //     newY = e?.touches[0]?.pageY - containerRect.top;
    // } else {
    //     newX = e.pageY - containerRect.left;
    //     newY = e.pageY - containerRect.top;
    // }
    if (e?.pageX && e?.pageY) {
        newX = e?.pageX - containerRect.left;
        newY = e?.pageY - containerRect.top;
    } else {
        newX = e?.touches[0].pageX - containerRect.left;
        newY = e?.touches[0].pageY - containerRect.top;
    }

    // Adjust for menu dimensions
    const menuWidth = 230; // Width of the context menu
    const menuHeight = 210; // Approx height of the context menu
    
    // Ensure the menu stays within the container
    if (newX + menuWidth > containerWidth) {
        newX = containerWidth - menuWidth;
    }
    if (newY + menuHeight > containerHeight) {
        newY = containerHeight - menuHeight;
    }
    
    // Ensure menu does not go out of the top/left boundaries
    newX = Math.max(0, newX);
    newY = Math.max(0, newY);
    
    chart
        .renderer
        .label(contextMenu, newX, newY, 'rect', null, null, true)
        .addClass('contMenu')
        .attr({ zIndex: 10 })
        .add();
    
    // <-----------------New version----------------------->  
    jQuery('#parentUl').show();
    setTimeout(() => {
        jQuery(document).on('click.contextMenu', function (event) {
            if (!jQuery(event.target).closest('.contMenu').length && !jQuery(event.target).closest('.highcharts-container').length) {
                jQuery('.contMenu').remove();
                jQuery(document).off('click.contextMenu'); // Remove the handler once used
            }
        });
    }, 10);
    document.addEventListener('touchstart', function (event) {
        if (!event.target.closest('.contMenu') && !event.target.closest('.highcharts-container')) {
            jQuery('.contMenu').remove();
            document.removeEventListener('touchstart', this);
        }
    }, { once: true });
}